<template>
  <!-- Registration-form -->
  <div class="registration-form l-container">
    <RakutenLogin
      v-if="isConfirm"
      @rakutenConfirm="setConfirm"
      @isLogin="loginRakuten"
    />
    <!-- Step -->
    <div class="step">
      <Step :currentStep="1" :steps="steps" />
    </div>
    <div class="title-top">申込確認</div>
    <div class="divider-top"></div>
    <div class="box">
      <div class="box-content">
        <!-- Item-order -->
        <SectionContentTitle
          :lineType="'v-line'"
          :titleContent="'お申し込み内容'"
          class="pb-4 text-xl sm:text-sm"
        />
        <div>
          <Item :data="dataItemOrder" />
        </div>
        <!-- Item-detail -->
        <div class="customer-info-detail">
          <!-- <TableDetail v-model="TableDetail1" /> -->
          <div>
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">宿泊期間</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <span class="mr-2">{{
                        customerPlan ? customerPlan.stayDayJP : ''
                      }}</span>
                      <span class="mr-2"
                        >{{ customerPlan ? customerPlan.stayNights : '' }} 泊</span
                      >
                      <span class="mr-2"
                        >{{ customerPlan ? customerPlan.stayRooms : '' }} 部屋</span
                      >
                      <span class="mr-2"
                        >（大人{{ totalAdultPeople | formatInteger }}名/子ども{{
                          totalChildren | formatInteger
                        }}名）</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp border-t-0">
                <td class="flex style-l">
                  <div class="font-bold label-l">チェックイン時間</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data">
                      <span>{{ checkinTime }}:00</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp border-t-0" v-if="!isRakuten">
                <td class="flex style-l">
                  <div class="font-bold label-l">交通手段</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data">
                      <span>{{ vehicle }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <!-- <div v-for="(item, index) in customerPlan.stayRooms" :key="index"> -->

          <!-- <SectionContentTitle
            :lineType="'v-line'"
            :titleContent="'部屋'"
            class="text-xl sm:text-sm"
          /> -->
          
          <div v-for="(stayRoom, idx) in stayRoomDetails" :key="`tbl-key-a-${idx}`">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="`${customerPlan ? idx + 1 : ''}部屋目`"
              class="pb-4 pt-6 text-xl sm:text-sm relative"
            />

            <div v-if="isRakutenPLan" class="mb-3">
              <div class="people-room mt-2 mb-3">
                <div class="room-row">
                  <div class="row-content">
                    <div class="elem center head">年齢区分</div>
                    <div class="elem center head">会員・ビジター</div>
                    <div class="elem center head">性別</div>
                    <div class="elem center head">宿泊代表者</div>
                  </div>
                </div>
                <!-- adult -->
                <template v-if="bsApp02001.adultTypeData.length">
                  <div class="room-row" v-for="people in bsApp02001.adultTypeData[idx]" :key="people.index">
                    <div class="row-content">
                      <div class="elem center body">大人</div>
                      <div class="elem center body">
                        {{people.type === 'member' ? '会員' : 'ビジター' }}
                      </div>
                      <div class="elem center body">
                        {{people.gender  === 'male' ? '男性' : '女性'}}
                      </div>
                      <div class="elem center body">
                        {{people.isDeputation  === true ? '代表者' : ''}}
                      </div>
                    </div>
                  </div>
                </template>
                <!-- children -->
                <template v-for="childType in Object.keys(stayRoom.memberChildren)">
                  <template v-if="bsApp02001.childTypeData.length && bsApp02001.childTypeData[idx] && bsApp02001.childTypeData[idx][childType].length">
                    <div
                      class="room-row"
                      v-for="child in bsApp02001.childTypeData[idx][childType]"
                      :key="`${childType}-${child.index}`"
                    >
                      <div class="row-content">
                        <div class="elem center body">{{ childTypeLabel[childType] }}</div>
                        <div class="elem center body">
                          {{child.type === 'member' ? '会員' : 'ビジター' }}
                        </div>
                        <div class="elem center body">
                          {{child.gender  === 'male' ? '男性' : '女性'}}
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
              
              <template>
                <div class="mt-6">
                  <div class="mb-3">代表者氏名</div>
                  <div class="representative">
                    <div class="row-content">
                      <div class="elem">氏名（かな）</div>
                      <div class="elem" wovn-ignore>
                        {{
                          bsApp02001.deputyInfo[idx].familyNameKana +
                          bsApp02001.deputyInfo[idx].firstNameKana
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="representative">
                    <div class="row-content">
                      <div class="elem">氏名（ローマ字）</div>
                      <div class="elem" wovn-ignore>
                        {{
                          bsApp02001.deputyInfo[idx].familyName +
                          bsApp02001.deputyInfo[idx].firstName
                          }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <table v-if="checkBaseOnPricePeople" class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">会員</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div>
                        <div
                          class="sub-items block"
                          v-for="(el, idx) in stayRoom.displayMembers"
                          :key="`tbl-key-a11-${idx}`"
                        >
                          <div v-show="el.stayDays.length">
                            <div class="flex justify-between">
                              <div>{{ el.name }}</div>
                              <div class="flex flex-col">
                                <span
                                  class="text-right"
                                  v-for="(day, dayIndex) in el.stayDays"
                                  :key="`tbl-key-day-${dayIndex}`"
                                >
                                  <span v-show="+dayIndex === 0">1</span
                                  ><span v-show="dayIndex > 0">{{ dayIndex + 1 }}</span
                                  >泊目
                                  <span v-show="checkBaseOnPricePeople">
                                    {{ Math.round(day.price) | formatInteger }}円 x
                                    {{ day.quantity }}名 =
                                    {{ Math.round((day.price * day.quantity)) | formatInteger }}円
                                  </span>

                                  <span v-show="!checkBaseOnPricePeople">
                                    {{ Math.round(day.price / stayRoom.totalAdultMember) | formatInteger }}円 x
                                    {{ day.quantity }}名 =
                                    {{ Math.round(day.price / stayRoom.totalAdultMember) * day.quantity | formatInteger }}円
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp border-t-0" v-if="!visibleVisitor">
                <td class="flex style-l">
                  <div class="font-bold label-l">ビジター</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div>
                        <div
                          class="sub-items block"
                          v-for="(el, idx) in stayRoom.displayVisitors"
                          :key="`tbl-key-b1-${idx}`"
                        >
                          <div v-show="el.stayDays.length">
                            <div class="flex justify-between">
                              <div>{{ el.name }}</div>
                              <div class="flex flex-col">
                                <span
                                  class="text-right"
                                  v-for="(day, dayIndex) in el.stayDays"
                                  :key="`tbl-key-day-${dayIndex}`"
                                >
                                  <span v-show="+dayIndex === 0">1</span
                                  ><span v-show="dayIndex > 0">{{ dayIndex + 1 }}</span
                                  >泊目
                                  <span v-show="checkBaseOnPricePeople">
                                    {{ Math.round(day.price) | formatInteger }}円 x
                                    {{ day.quantity }}名 =
                                    {{ Math.round((day.price * day.quantity)) | formatInteger }}円
                                  </span>

                                  <span v-show="!checkBaseOnPricePeople">
                                    {{ Math.round(day.price / stayRoom.totalAdultVisitor) | formatInteger }}円 x
                                    {{ day.quantity }}名 =
                                    {{ Math.round(day.price / stayRoom.totalAdultMember) * day.quantity | formatInteger }}円
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <div
              class="total-price"
              :class="{'room-price' : !checkBaseOnPricePeople}">
              <p
                class="total-price-text font-16"
                :class="{'room-price-text' : !checkBaseOnPricePeople}"
              >{{ idx + 1 }}部屋目の宿泊料合計:</p>  
              <p
                class="total-price-amount font-16"
                :class="{'room-price-amount' : !checkBaseOnPricePeople}">
                {{ checkBaseOnPricePeople
                ? (Math.round(stayRoom.roomAmount) | formatCurrency)
                : Math.round(totalRoomAmount(stayRoom.stayDays)) | formatCurrency }}
              </p>
            </div>
          </div>

          <div class="total-price mb-1">
            <p class="total-price-text">宿泊料合計</p>
            <p class="total-price-amount">{{ feePeople | formatCurrency }}</p>
          </div>
          <div v-if="checkBaseOnPricePeople" class="flex flex-col items-end mb-3 text-xs">
            <span>
              宿泊料金に1円未満の端数が発生する場合、
            </span>
            <span>
              1人あたり料金は切り上げ表示としてあります。
            </span>
          </div>
          <a-divider />
          <!-- Customer-info -->
          <div class="customer-info">
            <!-- Title -->
            <div class="customer-info-title">
              <SectionContentTitle
                :lineType="'v-line'"
                :titleContent="'申込者情報'"
                class="my-auto text-xl sm:text-sm"
              />
            </div>

            <!-- Customer-information -->
            <CustomerInfo
              @onChange="getCustomerInfo($event)"
              :updateInfoCustomer="updatePostCode"
            />
            <div class="modify-button">
              <a-button
                @click="popupAddressInfo = true"
                size="large"
                class="text-bold sm:text-sm"
                >変更する</a-button
              >
            </div>
          </div>
          <a-divider />
          <SectionContentTitle
            :titleContent="'宿泊代表者'"
            class="text-base mt-8 pb-4 sm:text-xs"
          />
          <div v-if="!isRakutenPLan && !representativeInfo.phoneNumber">
            <span>宿泊代表者は申込者と同じ</span>
          </div>
          <div v-else-if="!isRakutenPLan">
            <span>宿泊代表者は申込者と異なる</span>
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">宿泊代表者</div>
                  <div class="ml-4 category">必須</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">氏名（かな・ローマ字）</div>
                        <div class="elm2" wovn-ignore>
                          {{
                            representativeInfo.familyNameKana +
                            representativeInfo.firstNameKana
                          }}
                        </div>
                      </div>
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">氏名（漢字・ローマ字）</div>
                        <div class="elm2" wovn-ignore>
                          {{
                            representativeInfo.familyName +
                            representativeInfo.firstName
                          }}
                        </div>
                      </div>
                      <div class="content-data collapse-data">
                        <div class="elm1">連絡先電話番号</div>
                        <div class="elm2" wovn-ignore>{{ representativeInfo.phoneNumber }}</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div v-else class="mb-3">
            <div class="representative">
              <div class="row-content">
                <div class="elem">氏名（かな・ローマ字）</div>
                <div class="elem" wovn-ignore>
                  {{
                    representativeInfo.familyNameKana +
                    representativeInfo.firstNameKana
                  }}
                </div>
              </div>
            </div>
            <div class="representative">
              <div class="row-content">
                <div class="elem">氏名（漢字・ローマ字）</div>
                  <div class="elem" wovn-ignore>
                    {{
                      representativeInfo.familyName +
                      representativeInfo.firstName
                    }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="questionList && questionList.length > 0">
            <div class="mt-4">
              <SectionContentTitle
                lineType="v-line"
                titleContent="宿泊施設からのご確認事項"
              />
            </div>
            <div class="checklist" v-for="(item, index) in questionList" :key="index">
              <div class="main-checklist">
                <div class="checklist-title">
                  {{ item.qstnCont }}
                  <div class="w-8 ml-1 mt-1 category" v-if="item.replyIdpsbFlag === '1'">
                    必須
                  </div>
                </div>
                <div class="checklist-content" v-if="item.replyRem">
                  <div class="pl-5 py-4" wovn-ignore>
                    <p wovn-ignore style="white-space: pre-wrap">{{ item.replyRem }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="modify-button">
              <a-button @click="handleEdit(2)" size="large" class="text-bold sm:text-sm"
                >変更する</a-button
              >
            </div>
          </div>
          <a-divider />

          <div class="subsidy-usage" v-if="subsidyAvailables.length > 0 && !cannotApplyCoupon">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="'補助クーポン利用申請'"
              class="pt-4 text-xl sm:text-sm"
            />
            <!-- Company-subsidize -->
            <div class="company-subsidize hidden">
              <span class="text">企業補助適用額</span>
              <span class="money">{{ fee4 }} 円</span>
            </div>
            <div class="auxiliary-coupon">
              <!-- Coupon-A -->
              <div class="label-coupon hidden">
                <span class="type">補助クーポンA</span>
                <span class="description">
                  適用条件：対象期間 2021年4月1日〜2022年3月31日
                </span>
              </div>
              <div class="hidden">
                <table class="table-common">
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">数量</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data">
                        <div class="label-data w-full">
                          <div class="sub-items">
                            <div class="grid">
                              <span> 大人男性 1名 </span>
                              <span> 大人男性 1名 </span>
                            </div>
                            <div class="grid price-cal">
                              <span> </span>
                              <span class="font-bold"> 3,000円分 </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">代表宿泊者</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data">
                        <div class="label-data w-full">
                          <div class="sub-items">
                            <div class="grid">
                              <span> 大人男性 1名 </span>
                              <span> 大人男性 1名 </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- Coupon-B -->
              <!-- Table-detail-6 -->
              <div>
                <table class="table-common">
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">数量</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data">
                        <div class="label-data w-full">
                          <div
                            class="sub-items"
                            v-if="couponForceTotal && couponOptionTotal"
                          >
                            <div class="grid">
                              <span> 利用する（自動補助クーポン） </span>
                              <span>
                                {{
                                  couponOptionTotalPopUp ? '利用する' : '未選択'
                                }}（選択補助クーポン）
                              </span>
                            </div>
                            <div class="grid price-cal">
                              <span class="font-bold">
                                {{ couponForceTotal | formatCurrency }}分
                              </span>
                              <span class="font-bold" v-if="couponOptionTotalPopUp">
                                {{ couponOptionTotalPopUp | formatCurrency }}分
                              </span>
                            </div>
                          </div>
                          <div
                            class="sub-items"
                            v-if="couponForceTotal && !couponOptionTotal"
                          >
                            <div class="grid">
                              <span> 利用する（自動補助クーポン） </span>
                            </div>
                            <div class="grid price-cal">
                              <span class="font-bold">
                                {{ couponForceTotal | formatCurrency }}分
                              </span>
                            </div>
                          </div>
                          <div
                            class="sub-items"
                            v-if="couponOptionTotal && !couponForceTotal"
                          >
                            <div class="grid">
                              <span>
                                {{
                                  couponOptionTotalPopUp ? '利用する' : '未選択'
                                }}（選択補助クーポン）
                              </span>
                            </div>
                            <div class="grid price-cal">
                              <span> </span>
                              <span class="font-bold" v-if="couponOptionTotalPopUp">
                                {{ couponOptionTotalPopUp | formatCurrency }}分
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="
                              couponForceTotal &&
                              !couponOptionTotal &&
                              !couponOptionTotalPopUp &&
                              noUseCouponOption
                            "
                          >
                            利用しない（選択補助クーポン）
                          </div>
                          <div
                            class="sub-items"
                            v-show="!couponForceTotal && !couponOptionTotal"
                          >
                            <div class="grid">
                              <span> 利用しない </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-if="forcedCouponOnly" class="modify-button flex justify-end gap-x-2">
                  <div
                    v-if="subsidyAvailables.length"
                    class="available-coupon-balloon"
                  >
                    <p>利用できる補助クーポンがあります</p>
                  </div>
                  <a-button
                  @click="onClickOpenCoupon()"
                  size="large"
                  class="text-bold sm:text-sm"

                  >確認する</a-button
                  >
              </div>
              <div v-else class="modify-button flex justify-end gap-x-2">
                <div
                  v-if="subsidyAvailables.length"
                  class="available-coupon-balloon"
                >
                  <p>利用できる補助クーポンがあります</p>
                </div>
                <a-button
                  @click="onClickOpenCoupon()"
                  size="large"
                  class="text-bold sm:text-sm"
                  :disabled="
                    !subsidyAvailables.length || cannotApplyCoupon || !activeCouponBtn
                  "
                  :class="[
                    !subsidyAvailables.length || cannotApplyCoupon || !activeCouponBtn
                      ? 'btn-disable'
                      : ''
                  ]"
                  >申請する</a-button
                >
                <a-button
                  @click="donotUseCoupon()"
                  size="large"
                  class="text-bold sm:text-sm"
                  :disabled="
                    !subsidyAvailables.length || cannotApplyCoupon || !activeCouponBtn
                  "
                  :class="[
                    !subsidyAvailables.length || cannotApplyCoupon || !activeCouponBtn
                      ? 'btn-disable'
                      : ''
                  ]"
                  >申請しない</a-button
                >
              </div>
            </div>
            <a-divider />
          </div>

          <!-- カフェ利用 -->
          <div class="benepo-usage-app" v-if="isCafeDisplay">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="'カフェポイント利用申請'"
              class="pt-4 text-xl sm:text-sm"
            />
            <div>
              <table class="table-common">
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">数量</div>
                    <div class="ml-4 category">必須</div>
                  </td>
                  <td class="data">
                    <div class="items-data">
                      <div class="label-data w-full">
                        <div class="sub-items">
                          <div class="grid">
                            <span>
                              {{ cafeLabel }}
                            </span>
                          </div>
                          <div class="grid price-cal">
                            <span> </span>
                            <span class="font-bold">
                              {{ cafeApplyAmount | formatCurrency }}分
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modify-button flex justify-end gap-x-2">
              <a-button
                @click="showCafeModal()"
                size="large"
                class="text-bold sm:text-sm"
                :disabled="!activeCafe || !totalCost"
                :class="[
                  !activeCafe || !totalCost ? 'btn-disable' : ''
                ]"
                >申請する</a-button
              >
              <a-button
                @click="notUseCafe()"
                size="large"
                class="text-bold sm:text-sm"
                :disabled="!activeCafe || !totalCost"
                :class="[
                  !activeCafe || !totalCost ? 'btn-disable' : ''
                ]"
                >申請しない</a-button
              >
            </div>
          </div>

          <div class="benepo-usage-app" v-if="benepoUseFlag && benepoUseFlag === '1'">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="'ベネポ利用申請'"
              class="pt-4 text-xl sm:text-sm"
            />
            <div>
              <table class="table-common">
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">数量</div>
                    <div class="ml-4 category">必須</div>
                  </td>
                  <td class="data">
                    <div class="items-data">
                      <div class="label-data w-full">
                        <div class="sub-items">
                          <div class="grid">
                            <span>
                              {{ benepointLabel }}
                            </span>
                          </div>
                          <div class="grid price-cal">
                            <span> </span>
                            <span class="font-bold">
                              {{ applyBenepoints | formatCurrency }}分
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modify-button flex justify-end gap-x-2">
              <a-button
                @click="showPopupBenepoint()"
                size="large"
                class="text-bold sm:text-sm"
                :disabled="!activeBtnBenepoint || !totalCost"
                :class="[
                  !activeBtnBenepoint || !totalCost ? 'btn-disable' : ''
                ]"
                >申請する</a-button
              >
              <a-button
                @click="unuseBenepoint()"
                size="large"
                class="text-bold sm:text-sm"
                :disabled="!activeBtnBenepoint || !totalCost"
                :class="[
                  !activeBtnBenepoint || !totalCost ? 'btn-disable' : ''
                ]"
                >申請しない</a-button
              >
            </div>
          </div>
          <a-divider />
          <div class="flex justify-end">
            <a-button
              size="large"
              class="text-bold sm:text-sm"
              @click="
                clearBenepoint()
                resetCoupons()
                clearCafe()
              "
              >やり直す</a-button
            >
          </div>
          <a-divider class="mb-2" />
          <div
            v-if="
              payeeDiv == this.CONST_DATA.STAY_PAYEE_DIV.LOCALLY ||
              payeeDiv == this.CONST_DATA.STAY_PAYEE_DIV.ADVANCE ||
              payeeDiv == this.CONST_DATA.STAY_PAYEE_DIV.SELECTABLE
            "
            style="text-align: center;"
          >
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">支払い方法</div>
                  <div class="ml-4 category">必須</div>
                </td>
                <td class="data">
                  <a-select
                    v-model="payeeDivMethod"
                    style="text-align: left;"
                    class="w-1/2 sm:w-full"
                  >
                    <a-select-option
                      v-if="payeeDiv != this.CONST_DATA.STAY_PAYEE_DIV.ADVANCE"
                      value="local"
                      key="site-1"
                      style="display: block;"
                    >
                      現地でお支払い
                    </a-select-option>
                    <a-select-option
                      v-if="payeeDiv != this.CONST_DATA.STAY_PAYEE_DIV.LOCALLY"
                      value="credit"
                      key="site-2"
                      style="display: block;"
                    >
                      クレジットカードでお支払い
                    </a-select-option>
                  </a-select>
                </td>
              </tr>
            </table>
            
          </div>
          <div class="fees">
            <div class="fee-item">
              <div class="item-title">
                <span>宿泊料合計①</span>
              </div>
              <div class="item-price">
                <span>{{ feePeople | formatCurrency }}</span>
              </div>
            </div>
            <div class="fee-item py-3">
              <div class="item-title-1">
                <p>（うち消費税（10%）</p>
              </div>
              <div class="item-price-1">
                <p>{{ Math.round(feePeople * (1 / 11)) | formatCurrency }})</p>
              </div>
            </div>
            <div class="fee-item py-3">
              <div class="item-title">
                <span>申請額合計②</span>
              </div>
              <div class="item-price">
                <span>{{
                  Math.round(fee4 + applyBenepoints + cafeApplyAmount + totalSubsidyDiscount)
                    | formatCurrency
                }}</span>
              </div>
            </div>
            <div class="fee-item py-3">
              <div class="item-title">
                <span>負担予定額（① - ②）</span>
              </div>
              <div class="item-price">
                <span>{{ totalCost | formatCurrency }}</span>
              </div>
            </div>
            <div class="fee-item" v-show="grantedBenepo != null">
              <div class="item-title">
                <p>獲得予定ベネポ</p>
              </div>
              <div class="item-price">
                <p>{{ grantedBenepo | formatDecimal }}P</p>
              </div>
            </div>
            <div class="fee-item py-3">
              <div  v-if="payeeDivMethod == 'credit'" class="item-title" style="width: 100%">
                <span>お支払い金額（クレジットカード）</span>
              </div>
              <div v-else class="item-title" style="width: 100%">
                <span>お支払い金額</span>
              </div>
              <div class="item-price">
                <span>{{ totalCost | formatCurrency }}</span>
              </div>
            </div>
          </div>

          <a-divider />
          <div class="">
            <!-- <SectionContentTitle
              :titleContent="'変更・キャンセルについて'"
              class="pb-1 pt-4 text-sm sm:text-sm sm:pb-2"
            /> -->
            <div class="confirmation-detail mb-0 pt-5 hidden">
              <p class="hidden">
                ※テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
              </p>
              <span class="font-bold pr-5">支払方法</span>
              <a-select
                class="pr-5"
                default-value="10"
                style="width: 180px"
                @change="handleChange"
              >
                <a-select-option value="10"> 銀行 </a-select-option>
                <a-select-option value="20"> クレジットカード </a-select-option>
              </a-select>
              <button @click="handlePayment()" class="c-btn btn-grey btn-1 w-32 hidden">
                <span class="">Apply</span>
              </button>
            </div>
          </div>
          <!-- <a-divider /> -->
          <div class="mb-16 hidden">
            <SectionContentTitle
              :titleContent="'システムアイ'"
              class="pt-4 text-xl sm:text-sm"
            />
            <div>
              <a-radio-group v-model="siteController" class="sm:flex sm:flex-col">
                <a-radio
                  :value="site.value"
                  v-for="(site, index) in siteControllerList"
                  :key="`site-${index}`"
                >
                  {{ site.label }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>

          <!-- Cancel Policy -->
          <section
            class="pb-2 pt-4 sm:pt-2"
            v-if="cancelPolicy && cancelPolicy.cancelPolicies"
          >
            <div
              class="cancel-policy"
              v-for="(ele, index) in cancelPolicy.cancelPolicies"
              :key="`cancel-policy-${index}`"
            >
              <SectionContentTitle
                class="v-line"
                lineType=""
                :titleContent="ele.cancelTitle"
              />
              <p
                class="whitespace-pre-wrap"
                v-html="ele.cancelNote1.replaceAll('\n', '<br>')"
                v-if="ele.cancelNote1"
              ></p>
              <p
                class="whitespace-pre-wrap text-grey-600 mb-2 mt-2"
                style="font-size: 14px"
                v-html="
                  `※オンラインカード決済の予約をキャンセルした場合の返金については、 ご予約時にご利用いただいたクレジットカードに対し返金処理が行われます。予約がキャンセルされると、ベネフィット・ワンから決済代行会社を経由して、お客様のカード会社へ返金情報が連携されます。カード会社から返金されるまでは、1～2か月程度かかります。返金日については、ご利用のカード会社へお問い合わせください。`
                "
              ></p>
              <p
                class="whitespace-pre-wrap text-grey-600 mb-2 mt-2"
                style="font-size: 14px"
                v-html="ele.cancelNote2.replaceAll('\n', '<br>')"
                v-if="ele.cancelNote2"
              ></p>
              <p
                class="whitespace-pre-wrap text-grey-600 mb-2 mt-2"
                style="font-size: 14px"
                v-html="
                  `※カフェテリアポイント・ベネポおよび企業補助金はキャンセル料へは適用できません。</br>キャンセル料は、カフェテリアポイント・ベネポおよび企業補助金適用前の料金から起算いたします。`
                "
              ></p>
              <p
                class="whitespace-pre-wrap text-grey-600 mb-6 mt-2"
                v-html="
                  `※ キャンセル料金は利用料金の税抜金額に対して発生します`
                "
                v-show="checkCancelFlag"
              ></p>
              <a-table
                class="sm:hidden block pb-3"
                :columns="cancelPolicyColumns"
                :data-source="ele.cancelPolicyTable"
                :rowKey="
                  (item, index) => {
                    return index
                  }
                "
                v-if="ele.cancelPolicyTable"
                bordered
              >
              </a-table>
              <div class="cancel-policy_inner">
                <div
                  class="cancel-policy_inner_block"
                  v-for="(e, index) in ele.cancelPolicyTable"
                  :key="`cancel-policy-${index}`"
                >
                  <div class="cancel-policy_inner_block--title">{{ e.cancelRule }}</div>
                  <div class="cancel-policy_inner_block--content-flex">
                    <span>規定率：</span>
                    <p>{{ e.cancelCond }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Divider -->
          </section>
          
          <!-- メルマガ機能はリリース時点で見送りとなっているためコメントアウト　2023年3月16日 -->
          <!-- <section class="pt-4">
            <SectionContentTitle
              class=""
              lineType="v-line"
              titleContent="新着情報受信設定"
            />
            <div class="mb-4">
              <span>チェックを入れた内容の新着メニュー・プラン情報をお届けします。 </span>
            </div>
            <div class="flex gap-x-8 mb-4 sm:flex-col sm:gap-y-4">
              <a-checkbox class="m-0"> デイリーマガジン </a-checkbox>
              <a-checkbox class="m-0"> 週刊マガジン </a-checkbox>
              <a-checkbox class="m-0"> 月間マガジン </a-checkbox>
            </div>
            <div class="flex flex-col mb-4">
              <span>
                ※配信頻度は「あなたへのオススメ」の設定内容に準じたものとなります。
              </span>
              <span>
                ※配信停止は、マイページ「会員プロフィール設定」からお願いします。
              </span>
            </div>
          </section> -->

          <ConfirmPrivacy @change="changeConfirmPrivacy" :creditPay="payeeDivMethod"/>
          <a-divider />

          <div class="confirmation pt-2">
            <!-- Buttons -->
            <div class="buttons flex gap-2 justify-center mt-4 mb-4">
              <button @click="handleBack()" class="c-btn btn-white">
                <span class="">戻る</span>
              </button>
              <button
                @click="handleNext()"
                class="c-btn"
                :class="[isAcceptPrivacy ? 'btn-grey' : 'disabled-btn']"
                :disabled="!isAcceptPrivacy"
              >
                <span v-if="isStayRequest()" class="">リクエスト予約をする</span>
                <span v-else-if="payeeDivMethod == 'credit'" class="">次へ</span>
                <span v-else class="">予約を確定</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <UseCouponPopup
      :visible="popupUseCoupon"
      @ok="onApplyCoupon"
      @getTotalCoupon="getTotalCoupon"
      @cancel="popupUseCoupon = false"
    />
    <!-- カフェポ利用申請モーダル -->
    <CafeApplyModal
      :visible="popupUseCafe"
      :cafeInfo="cafeData"
      :totalPrice="totalMemberPrice"
      :totalAdult="memberAdultsCnt"
      :totalChildren="memberChildrenCnt"
      :stayDays="stayDays"
      :subsidyTotal="calcCoupon"
      :useDate="useDate"
      @apply="setUseCafe($event)"
      @hide="hideCafeModal"
    />
    <UseBenepointPopup
      :visible="popupUseBenepoint"
      :useCafe="cafeApplyAmount"
      @ok="handleBenepoint"
      @cancel="cancelPopupBenepoint"
      size="large"
    />

    <AddressInfo
      :visible="popupAddressInfo"
      @cancel="cancelPopupInfo"
      @ok="handlePopupInfo"
      @openAddressInfo="openAddressInfo"
      @updateInfoCustomer="updateInfoCustomer"
      size="large"
    />
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { bus } from '@/main'
import couponMixin from '@/mixins/coupon.js'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { SectionContentTitle, Item, Step } from '@/components/compound'
import CustomerInfo from './components/CustomerInfo'
import UseCouponPopup from './components/UseCouponPopup'
import UseBenepointPopup from './components/UseBenepointPopup'
import AddressInfo from './components/AddressInfo'
import {
  GET_ITEM_DETAIL,
  SAVE_DATA_BS_APP_02_001,
  SAVE_DATA_BS_APP_02_008
} from '@/store/modules/bs_app/actions'
import {
  CREATE_ORDER,
  CREATE_STAY_REQUEST,
  UPDATE_ORDER,
  SAVE_CUSTOMER_PLAN
} from '@/store/modules/plan/actions'
import {SET_ORDER} from '@/store/modules/order/mutations'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'
import ConfirmPrivacy from '@/components/common/ConfirmPrivacy/index.vue'
import { STEPS } from '@/constants/order.js'
import { CHILD_DIV } from '@/constants/child_div'
import CafeApplyModal from './components/CafeApplyModal'
import Mutex from '@/utils/mutex'
import constData from '@/mixins/const/constData';
import RakutenLogin from "@/components/RakutenLogin";

export default {
  components: {
    Item,
    SectionContentTitle,
    Step,
    CustomerInfo,
    UseCouponPopup,
    UseBenepointPopup,
    ConfirmPrivacy,
    AddressInfo,
    CafeApplyModal,
    RakutenLogin
  },
  name: 'BS_APP_02_005',
  mixins: [func_utils, plan_utils, couponMixin],
  data() {
    return {
      isNextClickEnabled: true,
      mutex: new Mutex(),
      steps: STEPS,
      customerInfo: null,
      dateFormat: 'YYYY-MM-DD',
      infoDetail: {},
      orderInfo: null,
      feePeople: 0,
      numberOfRooms: 1,
      text_note: '',
      checkinTime: '',
      price: {},
      fee4: 0,
      fee5: 20000,
      stayDays: 1,
      useDate: null,
      isUseBenepoint: null,
      textOptionCoupon: '利用しない',
      checkedBenepoint: null,
      valueCheckbox02_001: false,
      representPersonInfo: {},
      questionList: [],
      paymentMethod: '20',
      couponForceTotal: null,
      couponOptionTotal: null,
      activeBtnBenepoint: false,
      dataItemOrder: {
        type: 'type-small',
        label: '',
        menu_id: '',
        menu_content: '',
        title1: '',
        title2: ''
      },
      stay: [
        {
          name: '氏名（漢字・ローマ字）',
          content1: 'BENEFIT',
          content2: 'TARO'
        },
        {
          name: '会員との続柄',
          content1: '本人'
        },
        {
          name: '会員・ビジター',
          content1: '会員'
        },
        {
          name: '性別',
          content1: '男性'
        },
        {
          name: '年齢',
          content1: '56歳'
        }
      ],
      siteControllerList: [
        { label: 'TL-リンカーン', value: 'TL-Lincoln' },
        { label: '手間いらず', value: 'Temairazu' },
        { label: 'ねっぱん', value: 'Neppan' },
        { label: 'らく通', value: 'Raku2' },
        { label: 'かんざしクラウド', value: 'Kanxashi' }
      ],
      siteController: 'TL-Lincoln',
      totalAdultPeople: 0,
      totalChildren: 0,
      popupUseCoupon: false,
      popupUseBenepoint: false,
      orderDetail: null,
      stayRoomDetails: [],
      vehicle: null,
      cancelPolicy: null,
      grantedBenepo: null,
      pointGrntNumAmt: 0,
      grantedBenepoCallId: 0,
      isBenepoApiError: false,
      totalForceUseDiscount: null,
      cancelPolicyColumns: [
        {
          title: 'キャンセル日',
          dataIndex: 'cancelRule',
          width: 263
        },
        {
          title: '規定率',
          dataIndex: 'cancelCond'
        }
      ],
      displayMember: [],
      isAcceptPrivacy: false,
      subsidyAvailables: [],
      activeCouponBtn: true,
      cannotApplyCoupon: false,
      benepoUseFlag: null,
      payeeDiv: "",
      payeeDivMethod: "local",
      popupAddressInfo: false,
      updatePostCode: null,
      couponOptionTotalPopUp: null,
      noUseCouponOption: false,
      childTypeLabel: {
        childrenType10: '小学生高学年',
        childrenType15: '小学生低学年',
        childrenType20: '幼児食事・布団付',
        childrenType30: '幼児食事のみ',
        childrenType40: '幼児布団のみ',
        childrenType50: '幼児食事・布団不要'
      },
      isCafeDisplay: false,
      activeCafe: false,
      cafeAppliedFlg: false,
      cafeData: [],
      cafeMenuNo: "",
      cafeMenuBranchNo: "",
      cafeApplyAmount: 0,
      cafeApplyPoint: 0,
      popupUseCafe: false,
      cafeLabel: "利用しない",
      calcCoupon: 0,
      forcedCouponOnly: false,
      memberAdultsCnt: 0,
      memberChildrenCnt: 0,
      totalMemberPrice: 0,
      isConfirm: false
    }
  },
  created() {
    const documentTitle = sessionStorage.getItem('documentTitle', document.title)
    if(documentTitle){
      sessionStorage.removeItem('documentTitle')
      this.$meta.setDocumentTitle(documentTitle)
    }
  },
  mounted() {
    let orderData = _.get(this.$store.state, 'order.originCalendar', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    const bs_app_02_008 = null
    this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bs_app_02_008).then(() => {})
    const { menuNo, planId, roomId } = this.$route.query
    if (this.getBsApp02004) {
      const bsApp02004Data = this.getBsApp02004
      this.isUseBenepoint = bsApp02004Data.isUseBenepoint
    }
    if (this.getBsApp02008) {
      const bsApp02008Data = this.getBsApp02008
      this.checkedBenepoint = bsApp02008Data.checkedValue
      this.getBsApp02008.point_benepo = 0
      this.activeBtnBenepoint = false
    }
    this.getPlanBasicInfo()
    this.mountData()
    this.calcMemberCount();
    this.calcMemberPrice();
    // Check Subsidy
    this.getSubsidyCoupons(true)

    const checkInDay = moment(this.customerPlan?.stayDay)
    const checkOutDay = checkInDay.clone().add(this.customerPlan.stayNights, 'days')
    const adultHeadCnt = _.get(this.bsAppState, 'bs_app_02_001.stayRoomDetails[0].adultCount') || 1
    const exUpperGradesHeadCnt = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType10
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType10 || 0;
    const exLowerGradesHeadCnt = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType15
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType15 || 0;
    const youjiAHeadCnt        = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType20
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType20 || 0;
    const youjiBHeadCnt        = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType30
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType30 || 0;
    const youjiCHeadCnt        = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType40
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType40 || 0;
    const youjiDHeadCnt        = this.bsAppState.bs_app_02_001.stayRoomDetails[0].memberChildren.childrenType50
                                 + this.bsAppState.bs_app_02_001.stayRoomDetails[0].visitorChildren.childrenType50 || 0;
    const params = {
      checkInDay: checkInDay.format('YYYY/MM/DD'),
      checkOutDay: checkOutDay.format('YYYY/MM/DD'),
      adultHeadCnt,
      exUpperGradesHeadCnt: exUpperGradesHeadCnt,
      exLowerGradesHeadCnt: exLowerGradesHeadCnt,
      youjiAHeadCnt: youjiAHeadCnt,
      youjiBHeadCnt: youjiBHeadCnt,
      youjiCHeadCnt: youjiCHeadCnt,
      youjiDHeadCnt: youjiDHeadCnt,
    }
    this.$repositories('plan')
      .getStayParams({
        menuNo,
        planId,
        roomId,
        params
      })
      .then((stayParam) => {
        this.benepoUseFlag = stayParam?.payMthdInfo?.benepoUseFlag || '0'
        this.payeeDiv = stayParam?.payMthdInfo?.payeeDiv
        if(this.payeeDiv == this.CONST_DATA.STAY_PAYEE_DIV.ADVANCE) {
          this.payeeDivMethod = "credit"
        }
      })
    this.calcTotalVisitorPrice();
    // this.setCafeData();
  },
  watch: {
    async totalCostForGrantBenepo() {
      const result = await this.getGrantedBenePoint();
      if (result === null) return;
      if (result === -1) {
        this.isBenepoApiError = true;
        this.grantedBenepo = null;
        this.pointGrntNumAmt = 0;
        return;
      }
      this.isBenepoApiError = false;
      this.grantedBenepo = result;
      this.pointGrntNumAmt = result;
    },
    getBsApp02008(val) {
      const checkPoint = _.get(val, 'checkedValue', null)
      if (checkPoint || checkPoint === 0) {
        this.checkedBenepoint = checkPoint
      }
    }
  },
  computed: {
    isRakutenPLan() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd') === 'RakutenT'
    },

    visibleVisitor(){
      return this.getPlanInfo?.planUsage?.usageDetailStay?.visitorAvailDiv === '0'
    },
    salesformFlag() {
      return this.baseOnPrice == PLAN_BASE_ON_PRICE.ROOM ? 1 : 0
    },
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    checkBaseOnPricePeople() {
      return this.baseOnPrice === PLAN_BASE_ON_PRICE.PEOPLE
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    profileMe() {
      return this.$store.getters['auth/get'].profileMe
    },
    bsAppState() {
      return this.$store.getters.bs_app
    },
    bsApp02001() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_001', null)
    },
    getBsApp02004() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_004', null)
    },
    getBsApp02008() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_008', null)
    },
    totalSubsidyDiscount() {
      return _.get(this.customerPlan, 'couponPlanData.totalDiscountAmount', 0)
    },
    totalCost() {
      return this.feePeople -
        (this.fee4 + this.applyBenepoints + this.cafeApplyAmount + this.totalSubsidyDiscount) >
        0
        ? this.feePeople - (this.fee4 + this.applyBenepoints + this.cafeApplyAmount + this.totalSubsidyDiscount)
        : 0
    },
    totalCostForGrantBenepo() {
      return this.feePeople -
        (this.fee4 + this.applyBenepoints + this.totalSubsidyDiscount) >
        0
        ? this.feePeople - (this.fee4 + this.applyBenepoints + this.totalSubsidyDiscount)
        : 0
    },
    totalPeopleCnt () {
      // #71362 大人1人×子ども1名かつ、ベネポ付与種別：一律のパターンで表示・付与に誤りがあるため
      // 正しい人数算出処理になるよう src\views\BS_APP_02_001\index.vue をもとに実装
      return this.totalAdultPeople + this.totalChildren
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    getPlanDetail() {
      return this.$store.getters.planDetail
    },
    customerPlan() {
      return this.$store.getters.customerPlan
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.info_detail', null))
    },
    couponOption() {
      return _.get(this.$store.getters.customerPlan, 'couponPlanData.couponOption', null)
    },
    benepointLabel() {
      if (this.checkedBenepoint === null || this.checkedBenepoint === 2) {
        return '利用しない'
      } else if (this.checkedBenepoint === 0) {
        return 'すべてのポイントを利用する'
      } else if (this.checkedBenepoint === 1) {
        return '一部のポイントを利用する'
      }
      return '利用しない'
    },
    applyBenepoints() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_008.point_benepo', 0)
    },
    pointRemain() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_008.pointRemain', 0)
    },
    getOrderInfo() {
      return this.$store.getters.getOrder
    },
    getOrderId() {
      return _.cloneDeep(_.get(this.$store.state.order, 'orderId', null))
    },
    representativeInfo() {
      return _.get(this.bsApp02001, 'representativeInfo')
    },
    checkCancelFlag(){
      if(this.cancelPolicy?.canclTaxExcChrgFlag == 1) return true;
      return false;
    },
    isRakuten() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd', null) === 'RakutenT';
    },
    getOriginCalendar() {
      return _.cloneDeep(_.get(this.$store.state.order, 'originCalendar', null))
    }
  },
  methods: {
    setConfirm(val) {
      this.isConfirm = val
    },
    totalRoomAmount(stayDays) {
        let amount = 0
        // 部屋ごとの合計金額の計算
        if (Array.isArray(stayDays)) {
          stayDays.forEach(el => {
            amount += Math.round(el.price)
          })
        }
        return amount
    },
    cancelPopupInfo() {
      this.popupAddressInfo = false
    },
    handlePopupInfo() {
      this.popupAddressInfo = false
    },
    cancelPopupBenepoint() {
      this.popupUseBenepoint = false
    },
    showPopupBenepoint() {
      this.popupUseBenepoint = true
    },
    handleBenepoint($event) {
      this.popupUseBenepoint = false;
      this.activeBtnBenepoint = false;
      //this.activeCouponBtn = false;
    },
    /**
    * 獲得予定ベネポをMNから取得
    */
    async getGrantedBenePoint() {
      if(this.totalCostForGrantBenepo === 0) return 0
      // Increment call ID to detect and discard stale responses from concurrent calls
      const callId = ++this.grantedBenepoCallId;
      let returnBenepo = 0
      const stayRoomDetails = _.get(this.bsApp02001, 'stayRoomDetails')
      const benepoReturnInfo = this.getPlanDetail?.benepoReturnInfo;
      const { menuNo, planId } = this.$route.query
      this.grantedBenepo = null;
      if (stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
          let childrenType10 = 0
          let childrenType15 = 0
          let childrenType20 = 0
          let childrenType30 = 0
          let childrenType40 = 0
          let childrenType50 = 0
          let adultHeadCnt = 0

          for( let item of this.stayRoomDetails){
            adultHeadCnt += item.adultCount
            childrenType10 +=  item.memberChildren?.childrenType10,
            childrenType15 += item.memberChildren?.childrenType15,
            childrenType20 += item.memberChildren?.childrenType20,
            childrenType30 += item.memberChildren?.childrenType30,
            childrenType40 += item.memberChildren?.childrenType40,
            childrenType50 += item.memberChildren?.childrenType50
          }
          const params = {
              adultHeadCnt: adultHeadCnt,
              exUpperGradesHeadCnt: childrenType10,
              exLowerGradesHeadCnt: childrenType15,
              youjiAHeadCnt: childrenType20,
              youjiBHeadCnt: childrenType30,
              youjiCHeadCnt: childrenType40,
              youjiDHeadCnt: childrenType50
          }

          // #71362 大人だけで計算しているため、子どもも人数に含めるよう改修
          const benepoReturnDiv = this.totalPeopleCnt == 1 ? benepoReturnInfo?.benepoReturnDiv1:
            this.totalPeopleCnt > 1 ? benepoReturnInfo?.benepoReturnDiv2 : null;
          const benepoReturnFixed = this.totalPeopleCnt == 1 ? benepoReturnInfo?.benepoReturnFixed1:
            this.totalPeopleCnt > 1 ? benepoReturnInfo?.benepoReturnFixed2 : 0;
          if(benepoReturnDiv==='10'){
            try {
              let response= await this.$repositories('plan').getGrantedBenepoStay({ menuNo, planId, billingAmount : this.totalCostForGrantBenepo, params });
              // If a newer call has been made while waiting, discard this stale result
              if (callId !== this.grantedBenepoCallId) return null;
              returnBenepo = response.grantedBenepo;
            } catch (e) {
              if (callId !== this.grantedBenepoCallId) return null;
              console.error('granted-benepo-stay API failed:', e);
              return -1;
            }
          } else if(benepoReturnDiv==='20') returnBenepo = benepoReturnFixed;
      }
       return returnBenepo;
    },
    getTotalCoupon($event) {
      const couponObj = $event
      this.couponForceTotal = _.get(couponObj, 'couponForceTotal', null)
      this.couponOptionTotal = _.get(couponObj, 'couponOptionTotal', null)
      this.couponOptionTotalPopUp = _.get(couponObj, 'couponOptionTotal', null)
    },
    changeConfirmPrivacy(val) {
      this.isAcceptPrivacy = val
    },
    mountData() {
      const bs_app = _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app', null))

      const bs_app_02_001 = _.get(bs_app, 'bs_app_02_001', null)

      // const bs_app_02_008 = bs_app.bs_app_02_008
      if (bs_app_02_001) {
        this.questionList = _.get(bs_app_02_001, 'questionList', [])
        this.totalAdultPeople = bs_app_02_001.totalAdultPeople
        this.totalChildren = bs_app_02_001.totalChildren
        const moveDivNum = _.get(bs_app_02_001, 'othInfo.moveDiv', null)
        this.vehicle =
          +moveDivNum === 10 ? '車' : +moveDivNum === 20 ? '公共交通機関' : ''
        this.feePeople = bs_app_02_001.totalFee
          ? Math.round(bs_app_02_001.totalFee)
          : bs_app_02_001.totalFee
        this.grantedBenepo = _.get(bs_app_02_001, 'grantedBenepo', null)
        this.text_note = bs_app_02_001.text_note
        this.checkinTime = bs_app_02_001.checkinTime
        this.price = bs_app_02_001.price
        this.valueCheckbox02_001 = _.get(bs_app_02_001, 'valueCheckbox1', '')
        this.representPersonInfo.name = `${_.get(
          bs_app_02_001,
          'inputFormData.firstName',
          ''
        )} ${_.get(bs_app_02_001, 'inputFormData.familyName', '')}`
        this.representPersonInfo.familyRelationship = _.get(
          bs_app_02_001,
          'inputFormData.familyRelationship',
          ''
        )
        this.representPersonInfo.isVisitor =
          _.get(bs_app_02_001, 'inputFormData.isVisitor', '') === 0 ? '会員' : 'ビジター'
        this.representPersonInfo.gender =
          _.get(bs_app_02_001, 'inputFormData.gender', '') === 0 ? '男性' : '女性'
        this.representPersonInfo.age = _.get(bs_app_02_001, 'inputFormData.age', '')
        this.stayDays = this.customerPlan.stayNights
        this.cancelPolicy = _.get(this.getPlanDetail, 'cancelPolicy', [])
        let stayRoomDetails = bs_app_02_001.stayRoomDetails || []

        stayRoomDetails = stayRoomDetails.map((room) => {
          const displayMembers = [
            {
              name: '大人男性',
              type: 'memberMan',
              stayDays: []
            },
            {
              name: '大人女性',
              type: 'memberWoman',
              stayDays: []
            },
            {
              name: '小学生高学年',
              type: 'childrenType10',
              stayDays: []
            },
            {
              name: '小学生低学年',
              type: 'childrenType15',
              stayDays: []
            },
            {
              name: '幼児食事・布団付',
              type: 'childrenType20',
              stayDays: []
            },
            {
              name: '幼児食事のみ',
              type: 'childrenType30',
              stayDays: []
            },
            {
              name: '幼児布団のみ',
              type: 'childrenType40',
              stayDays: []
            },
            {
              name: '幼児食事・布団不要',
              type: 'childrenType50',
              stayDays: []
            }
          ]
          const displayVisitors = [
            {
              name: '大人男性',
              type: 'visitorMan',
              stayDays: []
            },
            {
              name: '大人女性',
              type: 'visitorWoman',
              stayDays: []
            },
            {
              name: '小学生高学年',
              type: 'childrenType10',
              stayDays: []
            },
            {
              name: '小学生低学年',
              type: 'childrenType15',
              stayDays: []
            },
            {
              name: '幼児食事・布団付',
              type: 'childrenType20',
              stayDays: []
            },
            {
              name: '幼児食事のみ',
              type: 'childrenType30',
              stayDays: []
            },
            {
              name: '幼児布団のみ',
              type: 'childrenType40',
              stayDays: []
            },
            {
              name: '幼児食事・布団不要',
              type: 'childrenType50',
              stayDays: []
            }
          ]

          // 子どもを大人としてカウントするか
          let childPriceInfo = {
            childPrice10: false,
            childPrice15: false,
            childPrice20: false,
            childPrice30: false,
            childPrice40: false,
            childPrice50: false
          }

          let totalAdultVisitor = room.adultCount || 0
          let totalAdultMember = room.adultCount || 0

          // 子どもの受け入れ設定がnullの場合はからの配列を入れる
          const childInfos =
          this.getPlanInfo &&
          this.getPlanInfo.vacancyCalendar &&
          this.getPlanInfo.vacancyCalendar.childPriceInfo &&
          this.getPlanInfo.vacancyCalendar.childPriceInfo.childInfos
          ? this.getPlanInfo.vacancyCalendar.childPriceInfo.childInfos
          : []

          childInfos.forEach(childInfos => {
            if(childInfos.calc == '1') {
              if (childInfos.childDiv == 10) {
                childPriceInfo.childPrice10 = true
                totalAdultVisitor += room.visitorChildren.childrenType10
                totalAdultMember += room.memberChildren.childrenType10
              } else if (childInfos.childDiv == 15) {
                childPriceInfo.childPrice15 = true
                totalAdultVisitor += room.visitorChildren.childrenType15
                totalAdultMember += room.memberChildren.childrenType15
              } else if (childInfos.childDiv == 20) {
                childPriceInfo.childPrice20 = true
                totalAdultVisitor += room.visitorChildren.childrenType20
                totalAdultMember += room.memberChildren.childrenType20
              } else if (childInfos.childDiv == 30) {
                childPriceInfo.childPrice30 = true
                totalAdultVisitor += room.visitorChildren.childrenType30
                totalAdultMember += room.memberChildren.childrenType30
              } else if (childInfos.childDiv == 40) {
                childPriceInfo.childPrice40 = true
                totalAdultVisitor += room.visitorChildren.childrenType40
                totalAdultMember += room.memberChildren.childrenType40
              } else if (childInfos.childDiv == 50) {
                childPriceInfo.childPrice50 = true
                totalAdultVisitor += room.visitorChildren.childrenType50
                totalAdultMember += room.memberChildren.childrenType50
              }
            }
          })

          room.stayDays.forEach((vacancy) => {
            displayVisitors.forEach((visitor, idx) => {
              if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
                // 室単位
                if (room.visitors.man && visitor.type === 'visitorMan') {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitors.man,
                    price: vacancy.adultPrice
                  })
                } else if (room.visitors.woman && visitor.type === 'visitorWoman') {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitors.woman,
                    price: vacancy.adultPrice
                  })
                } else if (
                  room.visitorChildren.childrenType10 &&
                  visitor.type === 'childrenType10'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType10,
                    price: childPriceInfo.childPrice10 ? vacancy.adultPrice : 0
                  })
                } else if (
                  room.visitorChildren.childrenType15 &&
                  visitor.type === 'childrenType15'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType15,
                    price: childPriceInfo.childPrice15 ? vacancy.adultPrice : 0
                  })
                } else if (
                  room.visitorChildren.childrenType20 &&
                  visitor.type === 'childrenType20'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType20,
                    price: childPriceInfo.childPrice20 ? vacancy.adultPrice : 0
                  })
                } else if (
                  room.visitorChildren.childrenType30 &&
                  visitor.type === 'childrenType30'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType30,
                    price: childPriceInfo.childPrice30 ? vacancy.adultPrice : 0
                  })
                } else if (
                  room.visitorChildren.childrenType40 &&
                  visitor.type === 'childrenType40'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType40,
                    price: childPriceInfo.childPrice40 ? vacancy.adultPrice : 0
                  })
                } else if (
                  room.visitorChildren.childrenType50 &&
                  visitor.type === 'childrenType50'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType50,
                    price: childPriceInfo.childPrice50 ? vacancy.adultPrice : 0
                  })
                }
              } else {
                // 人単位
                if (room.visitors.man && visitor.type === 'visitorMan') {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitors.man,
                    price: vacancy.adultPrice
                  })
                } else if (room.visitors.woman && visitor.type === 'visitorWoman') {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitors.woman,
                    price: vacancy.adultPrice
                  })
                } else if (
                  room.visitorChildren.childrenType10 &&
                  visitor.type === 'childrenType10'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType10,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                } else if (
                  room.visitorChildren.childrenType15 &&
                  visitor.type === 'childrenType15'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType15,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                } else if (
                  room.visitorChildren.childrenType20 &&
                  visitor.type === 'childrenType20'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType20,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                } else if (
                  room.visitorChildren.childrenType30 &&
                  visitor.type === 'childrenType30'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType30,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                } else if (
                  room.visitorChildren.childrenType40 &&
                  visitor.type === 'childrenType40'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType40,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                } else if (
                  room.visitorChildren.childrenType50 &&
                  visitor.type === 'childrenType50'
                ) {
                  displayVisitors[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.visitorChildren.childrenType50,
                    price: this.getVisitorChildPrice(
                      visitor.type,
                      vacancy.childrenPriceTable
                    )
                  })
                }
              }
            })
            displayMembers.forEach((member, idx) => {
              if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
                // 室単位
                if (room.member.man && member.type === 'memberMan') {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.member.man,
                    price: vacancy.price
                  })
                } else if (room.member.woman && member.type === 'memberWoman') {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.member.woman,
                    price: vacancy.price
                  })
                } else if (
                  room.memberChildren.childrenType10 &&
                  member.type === 'childrenType10'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType10,
                    price: childPriceInfo.childPrice10 ? vacancy.price : 0
                  })
                } else if (
                  room.memberChildren.childrenType15 &&
                  member.type === 'childrenType15'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType15,
                    price: childPriceInfo.childPrice15 ? vacancy.price : 0
                  })
                } else if (
                  room.memberChildren.childrenType20 &&
                  member.type === 'childrenType20'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType20,
                    price: childPriceInfo.childPrice20 ? vacancy.price : 0
                  })
                } else if (
                  room.memberChildren.childrenType30 &&
                  member.type === 'childrenType30'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType30,
                    price: childPriceInfo.childPrice30 ? vacancy.price : 0
                  })
                } else if (
                  room.memberChildren.childrenType40 &&
                  member.type === 'childrenType40'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType40,
                    price: childPriceInfo.childPrice40 ? vacancy.price : 0
                  })
                } else if (
                  room.memberChildren.childrenType50 &&
                  member.type === 'childrenType50'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType50,
                    price: childPriceInfo.childPrice50 ? vacancy.price : 0
                  })
                }
              } else {
                // 人単位
                if (room.member.man && member.type === 'memberMan') {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.member.man,
                    price: vacancy.price
                  })
                } else if (room.member.woman && member.type === 'memberWoman') {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.member.woman,
                    price: vacancy.price
                  })
                } else if (
                  room.memberChildren.childrenType10 &&
                  member.type === 'childrenType10'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType10,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                } else if (
                  room.memberChildren.childrenType15 &&
                  member.type === 'childrenType15'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType15,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                } else if (
                  room.memberChildren.childrenType20 &&
                  member.type === 'childrenType20'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType20,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                } else if (
                  room.memberChildren.childrenType30 &&
                  member.type === 'childrenType30'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType30,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                } else if (
                  room.memberChildren.childrenType40 &&
                  member.type === 'childrenType40'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType40,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                } else if (
                  room.memberChildren.childrenType50 &&
                  member.type === 'childrenType50'
                ) {
                  displayMembers[idx].stayDays.push({
                    stayDay: vacancy.stayDay,
                    quantity: room.memberChildren.childrenType50,
                    price: this.getMemberChildPrice(member.type, vacancy.childrenPriceTable)
                  })
                }
              }
            })
          })

          room.displayMembers = displayMembers
          room.displayVisitors = displayVisitors
          room.totalAdultVisitor = totalAdultVisitor
          room.totalAdultMember = totalAdultMember

          return room
        })

        this.stayRoomDetails = stayRoomDetails

        const updateBsApp02001 = _.clone(bs_app_02_001)
        updateBsApp02001.stayRoomDetails = stayRoomDetails
        this.$store.dispatch(SAVE_DATA_BS_APP_02_001, updateBsApp02001)
        this.getGrantedBenePoint(this.totalCostForGrantBenepo)
      }
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if (planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: planBasicInfo.planImages[0].imageUrl,
          title1: _.get(this.getPlanDetail, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    },
    getItemDetail() {
      this.$store.dispatch(GET_ITEM_DETAIL).then((data) => {
        this.dataItemOrder = data.dataItemOrder
      })
    },
    async getSubsidyCoupons(initFlg) {
      const today = moment()
      const planDetail = this.getPlanDetail
      const stayNights = this.customerPlan.stayNights
      // stayDay
      const checkInDay = moment(this.customerPlan?.stayDay)
      const checkOutDay = checkInDay.clone().add(stayNights - 1, 'days')
      this.$loading.show()
      let subsidyAvailables = await this.$repositories('coupon')
        .getSubsidyCouponList({
          reserveDateFrom: today.format('YYYY-MM-DD'),
          reserveDateTo: today.format('YYYY-MM-DD'),
          useDateFrom: checkInDay.format('YYYY-MM-DD'),
          useDateTo: checkOutDay.format('YYYY-MM-DD'),
          personAccompanyFlag: null,
          displayDiv: '2'
        })
        .catch((error) => {
          return error
        })
      if (!Array.isArray(subsidyAvailables)) {
        subsidyAvailables = []
      }
      subsidyAvailables = subsidyAvailables.filter(
        (s) =>{
          const receptionCheck = moment(s.availableData.receptionDateFrom).isSameOrBefore(today, 'day') &&
            moment(s.availableData.receptionDateTo).isSameOrAfter(today, 'day');
          const start = moment(s.availableData.applicableDateFrom);
          const end = moment(s.availableData.applicableDateTo);
          const lastNight = checkOutDay.clone().add(-1, 'days');

          const checkInDayCheck = checkInDay.isBetween(start, end, 'day', '[]');
          const checkOutDayCheck = lastNight.isBetween(start, end, 'day', '[]');
          const startCheck = start.isBetween(checkInDay, checkOutDay, 'day', '[)');
          const endCheck = end.isBetween(checkInDay, checkOutDay, 'day', '[)');

          return receptionCheck && (checkInDayCheck || checkOutDayCheck || startCheck || endCheck);
        }
      )

      if (subsidyAvailables.length > 0) {
        const subsidyIds = subsidyAvailables
          .map((s) => s.availableData.subsidyId)
          .join('-')
        // MAPPING
        const stationMapping = await this.$repositories('coupon')
          .getStationMapping({
            id: subsidyIds, // 0: subsidy, 1: cafe
            targetType: 0, // 0: subsidy, 1: cafe
            catLrgClassCd: _.get(
              planDetail,
              'menuInformation.categoryInfomation.catLrgClassCd',
              ''
            ),
            catMidClassCd: _.get(
              planDetail,
              'menuInformation.categoryInfomation.catMidClassCd',
              ''
            ),
            catSmlClassCd: _.get(
              planDetail,
              'menuInformation.categoryInfomation.catSmlClassCd',
              ''
            ),
            menuNo: _.get(planDetail, 'menuInformation.menuNo', ''),
            planId: _.get(planDetail, 'planBasicInfo.planId', ''),
            areaLrgClassCd: _.get(
              planDetail,
              'menuInformation.areaInfomation.areaLrgClassCd',
              ''
            ),
            areaMidClassCd: _.get(
              planDetail,
              'menuInformation.areaInfomation.areaMidClassCd',
              ''
            ),
            areaSmlClassCd: _.get(
              planDetail,
              'menuInformation.areaInfomation.areaSmlClassCd',
              ''
            ),
            areaDtlClassCd: _.get(
              planDetail,
              'menuInformation.areaInfomation.areaDtlClassCd',
              ''
            ),
            // receivableFlag: _.get(planDetail, 'planUsage.usageDetail.receivableFlag', ''),
            receivableFlag: '1',
            ticketExclusionFlag: _.get(
              planDetail,
              'planUsage.usageDetail.ticketExclusionFlag',
              ''
            ),
            buppanExclusionFlag: _.get(
              planDetail,
              'planUsage.usageDetail.buppanExclusionFlag',
              ''
            ),
            famiExclusionFlag: _.get(
              planDetail,
              'planUsage.usageDetail.famiExclusionFlag',
              ''
            )
          })
          .catch((error) => {
            return error
          })
        this.$loading.hide()
        if (stationMapping && stationMapping.bsSubsidyMappingArray) {
          const bsSubsidyIdMappings = stationMapping.bsSubsidyMappingArray.map(
            (e) => e.subsidyId
          )
          subsidyAvailables = subsidyAvailables.filter((c) =>
            bsSubsidyIdMappings.includes(c.availableData.subsidyId)
          )
        } else {
          subsidyAvailables = []
        }

        if (subsidyAvailables.length > 0) {
          // 保険クーポンの7日前に予約
          if (!moment().add(7, 'days').isSameOrBefore(this.customerPlan?.stayDay, 'day')) {
            subsidyAvailables = subsidyAvailables.filter(
              (s) => s.availableData.fiveDaysAgoControlFlg === "0"
            )
          }

          this.subsidyAvailables = subsidyAvailables.filter(
            (c) =>
              +c.availableData.useStopFlg === 0 &&
              c.availableData.subsidyType === '01' &&
              (c.availableRemainingCount === null || +c.availableRemainingCount > 0) &&
              (c.availableRemainingAmount === null || +c.availableRemainingAmount > 0)
          )
          //if (!this.subsidyAvailables.length) {
          //this.activeBtnBenepoint = true
          //}
          
          const forceUseCoupons = _.cloneDeep(this.subsidyAvailables).filter(
            (c) => c.availableData.usedFormDiv === '01'
          ) || []
          const optionalCoupons = _.cloneDeep(this.subsidyAvailables).filter(
            (c) => c.availableData.usedFormDiv !== '01'
          ) || []
          // stayDay,
          // stayNights,
          // coupons,
          // vacancyCalendar,
          // stayRoomDetails,
          const vacancyCalendar = this.customerPlan.vacancyCalendar
          const bsApp = this.$store.getters.bs_app
          const stayRoomDetails = bsApp.bs_app_02_001.stayRoomDetails

          const stayNightDetails = this.$_couponMixin_convertStayNightDetails(
            this.customerPlan.stayNights,
            stayRoomDetails,
            forceUseCoupons
          )

          const result = this.$_couponMixin_applyCoupon({
            stayDay: this.customerPlan.stayDay,
            stayNights: this.customerPlan.stayNights,
            coupons: forceUseCoupons,
            vacancyCalendar,
            stayNightDetails
          })

          const optionStayNightDetails = this.$_couponMixin_convertStayNightDetails(
            this.customerPlan.stayNights,
            stayRoomDetails,
            optionalCoupons
          )
          const optionalResult = this.$_couponMixin_applyCoupon({
            stayDay: this.customerPlan.stayDay,
            stayNights: this.customerPlan.stayNights,
            coupons: optionalCoupons,
            vacancyCalendar,
            stayNightDetails: optionStayNightDetails
          })

          if (
          (!result || !result.totalDiscountAmount) &&
          (!optionalResult || !optionalResult.totalDiscountAmount)
          ) {
            this.cannotApplyCoupon = true
          }
          
          // 強制補助金のみの場合のフラグを立てる
          if (result.totalDiscountAmount && !optionalResult.totalDiscountAmount) {
            this.forcedCouponOnly = true;
          }

          const customerPlan = _.cloneDeep(this.customerPlan)
          customerPlan['couponPlanData'] = null
          this.couponOptionTotal = optionalResult.totalDiscountAmount
          this.couponForceTotal = null
          if (result && result.totalDiscountAmount) {
            const memberChildrenCnt = Object.keys(this.customerPlan.memberChldDetails)
              .map((key) => this.customerPlan.memberChldDetails[key])
              .reduce((a, b) => a + b, 0)
            const visitorChildrenCnt = Object.keys(this.customerPlan.visitorChldDetails)
              .map((key) => this.customerPlan.visitorChldDetails[key])
              .reduce((a, b) => a + b, 0)
            const couponPlanData = {
              totalPeopleCnt: this.totalMemberCnt + this.totalVisitorCnt,
              memberAdults: this.customerPlan.memberAdults,
              memberChildrenCnt,
              visitorAdults: this.customerPlan.visitorAdults,
              visitorChildrenCnt,
              memberChldDetails: this.customerPlan.memberChldDetails,
              visitorChldDetails: this.customerPlan.visitorChldDetails,
              totalDiscountAmount: result.totalDiscountAmount,
              totalAppliedCouponPrice: result.totalAppliedCouponPrice,
              stayNightDetails: result.stayNightDetails,
              couponOption: null,
              verified: true,
              canUseOptional: null
            }
            customerPlan['couponPlanData'] = couponPlanData
            this.couponForceTotal = result.totalDiscountAmount
          }
          this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan)
        }
      } else {
        this.$loading.hide()
        this.couponForceTotal = null
        this.couponOptionTotal = null
        //this.activeBtnBenepoint = true
        const customerPlan = _.cloneDeep(this.customerPlan)
        customerPlan['couponPlanData'] = null
        this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan)
      }
      
      // 画面表示時、補助金取得後にカフェデータを取得する
      if (initFlg) {
        this.setCafeData();
      }    
    },
    getRoomAmount() {
      const stayDayDetails =
        this.customerPlan && Array.isArray(this.customerPlan)
          ? this.customerPlan.detailDays
          : []
      return stayDayDetails.map((e) => e.roomPrice).reduce((pre, cur) => pre + cur, 0)
    },
    /**
    * オーダーデータ初期化
    */
    getInitOrderData() {
      const couponPlanData = this.customerPlan.couponPlanData;
      const bsAppData = this.bsAppState;
      const addressInfo = _.get(bsAppData, 'info_detail');
      const currentOrder = this.getOrderInfo;

      if (currentOrder && currentOrder.acptNo) {
        return currentOrder
      }

      const postalCode = `${addressInfo.zipCode1}${addressInfo.zipCode2}`
      return {
        salesformFlag: this.salesformFlag,
        pointUseNumAmt: _.get(bsAppData, 'bs_app_02_008.point_benepo', 0),
        pointGrntNumAmt: this.pointGrntNumAmt || 0,
        aplySbsidAmt: couponPlanData?.totalDiscountAmount || 0,
        aplyCafePointAmt: 0,
        setlSts: '10',
        pointUseCd: null,
        reserveId: _.get(bsAppData, 'bs_app_02_001.reserveId', ''),
        customer: {
          customerNo: null, // bff で設定
          familyName: null, // bff で設定
          firstName: null, // bff で設定
          familyNameKana: null, // bff で設定
          firstNameKana: null, // bff で設定
          birthday: null, // bff で設定
          sex: null, // bff で設定
          prefectureCode: addressInfo.prefectureCode,
          postalCode: postalCode,
          address1: addressInfo.cityAddress,
          address2: addressInfo.apartment_number,
          addrNm: null,
          company: null,
          dept: null,
          tel: addressInfo.tel, // bff で設定 -> 59131 画面で入力された値をセットする
          email: null, // bff で設定
          courseId: null, // bff で設定
          companyCd: null, // bff で設定
          subscriptionId: null, // bff で設定
          priceDiv: null, // bff で設定
        },
        acptDtlDomesticStayList: [],
        cafeMenuNo: this.cafeMenuNo,
        cafeMenuBranchNo: this.cafeMenuBranchNo,
        cafeApplyAmount: this.cafeApplyAmount,
        cafeApplyPoint: this.cafeApplyPoint
      }
    },
    setBaseRoomPrice(data) {},
    setStayRoomDayPrticBasePeople(data, stayDayDetail, memberChildren, visitorChildren) {
      
      data.stayRoomDayPrtic.adultMemberChrg =
        stayDayDetail && stayDayDetail.price ? +stayDayDetail.price : 0

      data.stayRoomDayPrtic.adultvistrChrg =
      stayDayDetail && stayDayDetail.adultPrice ? +stayDayDetail.adultPrice : 0

      data.stayRoomDayPrtic.chldaMemberChrg = this.getMemberChildPrice('a', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldbMemberChrg = this.getMemberChildPrice('b', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldcMemberChrg = this.getMemberChildPrice('c', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chlddMemberChrg = this.getMemberChildPrice('d', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldeMemberChrg = this.getMemberChildPrice('e', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldfMemberChrg = this.getMemberChildPrice('f', stayDayDetail.childrenPriceTable)

      // visitor child price
      // plan_utils.js 内に処理を記載
      data.stayRoomDayPrtic.chldavistrChrg = this.getVisitorChildPrice('a', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldbvistrChrg = this.getVisitorChildPrice('b', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldcvistrChrg = this.getVisitorChildPrice('c', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chlddvistrChrg = this.getVisitorChildPrice('d', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldevistrChrg = this.getVisitorChildPrice('e', stayDayDetail.childrenPriceTable)
      data.stayRoomDayPrtic.chldfvistrChrg = this.getVisitorChildPrice('f', stayDayDetail.childrenPriceTable)

      data.stayRoomDayPrtic.adultBoneSbsidChrg = stayDayDetail?.boneSubsidy ? +stayDayDetail.boneSubsidy : 0 ;
      data.stayRoomDayPrtic.chldaBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'a',
        stayDayDetail?.childrenPriceTable
      )
      data.stayRoomDayPrtic.chldbBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'b',
        stayDayDetail?.childrenPriceTable
      )
      data.stayRoomDayPrtic.chldcBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'c',
        stayDayDetail?.childrenPriceTable
      )
      data.stayRoomDayPrtic.chlddBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'd',
        stayDayDetail?.childrenPriceTable
      )
      data.stayRoomDayPrtic.chldeBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'e',
        stayDayDetail?.childrenPriceTable
      )
      data.stayRoomDayPrtic.chldfBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'f',
        stayDayDetail?.childrenPriceTable
      )
    },
    setStayRoomDayPrticBasePeopleForStayRequest(data, stayDayDetail) {

      data.adultMemberChrg =
        stayDayDetail && stayDayDetail.price ? +stayDayDetail.price : 0

      data.adultvistrChrg =
      stayDayDetail && stayDayDetail.adultPrice ? +stayDayDetail.adultPrice : 0

      data.chldaMemberChrg = this.getMemberChildPrice('a', stayDayDetail.childrenPriceTable)
      data.chldbMemberChrg = this.getMemberChildPrice('b', stayDayDetail.childrenPriceTable)
      data.chldcMemberChrg = this.getMemberChildPrice('c', stayDayDetail.childrenPriceTable)
      data.chlddMemberChrg = this.getMemberChildPrice('d', stayDayDetail.childrenPriceTable)
      data.chldeMemberChrg = this.getMemberChildPrice('e', stayDayDetail.childrenPriceTable)
      data.chldfMemberChrg = this.getMemberChildPrice('f', stayDayDetail.childrenPriceTable)

      // visitor child price
      // plan_utils.js 内に処理を記載
      data.chldavistrChrg = this.getVisitorChildPrice('a', stayDayDetail.childrenPriceTable)
      data.chldbvistrChrg = this.getVisitorChildPrice('b', stayDayDetail.childrenPriceTable)
      data.chldcvistrChrg = this.getVisitorChildPrice('c', stayDayDetail.childrenPriceTable)
      data.chlddvistrChrg = this.getVisitorChildPrice('d', stayDayDetail.childrenPriceTable)
      data.chldevistrChrg = this.getVisitorChildPrice('e', stayDayDetail.childrenPriceTable)
      data.chldfvistrChrg = this.getVisitorChildPrice('f', stayDayDetail.childrenPriceTable)

      data.adultBoneSbsidChrg = stayDayDetail?.boneSubsidy ? +stayDayDetail.boneSubsidy : 0 ;
      data.chldaBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'a',
        stayDayDetail?.childrenPriceTable
      )
      data.chldbBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'b',
        stayDayDetail?.childrenPriceTable
      )
      data.chldcBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'c',
        stayDayDetail?.childrenPriceTable
      )
      data.chlddBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'd',
        stayDayDetail?.childrenPriceTable
      )
      data.chldeBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'e',
        stayDayDetail?.childrenPriceTable
      )
      data.chldfBoneSbsidChrg = this.getBoneSbsidChildPrice(
        'f',
        stayDayDetail?.childrenPriceTable
      )
    },
    /**
    * 宿泊オーダーデータ作成
    */
    setStayInfo(data) {
      const baseOnPrice = this.baseOnPrice
      const planDetail = this.getPlanDetail
      const bsAppState = this.bsAppState
      const bsApp = this.$store.getters.bs_app
      const bs_app_02_001 = bsApp.bs_app_02_001
      const deputyInfo = bs_app_02_001.deputyInfo
      const currentOrder = this.getOrderInfo
      const vacancyCalendars =
        this.customerPlan && this.customerPlan.vacancyCalendar
          ? this.customerPlan.vacancyCalendar.vacancyCalendars
          : []
      const stayDay = moment(this.customerPlan.stayDay)
      const menuStayParams = _.get(bsAppState, 'bs_app_02_001.menuStayParams', null)
      const representUserInfo = bs_app_02_001 ? bs_app_02_001.inputFormData : null
      const profile = _.get(bsAppState, 'bs_app_02_001.profileInfo', null)
      const couponPlanData = this.customerPlan.couponPlanData
      let totalAdultHead = 0
      let totalAdultMan = 0
      let totalAdultWoman = 0
      let totalMemberChilrenCnt = 0
      let countChildrenA = 0
      let countChildrenB = 0
      let countChildrenC = 0
      let countChildrenD = 0
      let countChildrenE = 0
      let countChildrenF = 0
      /// visit
      let totalVisitAdult = 0
      let totalVisitMan = 0
      let totalVisitWoman = 0
      let totalVisitChilrenCnt = 0
      let countVisitChildrenA = 0
      let countVisitChildrenB = 0
      let countVisitChildrenC = 0
      let countVisitChildrenD = 0
      let countVisitChildrenE = 0
      let countVisitChildrenF = 0

      let totalMemberChrg = 0
      let totalTieupChrg = 0
      let boneSbsidChrgTotalTemp = 0
      const acptPrticDomesticStayList = []
      bs_app_02_001.stayRoomDetails.forEach((room, index) => {
        const manMember = room.member && room.member.man ? room.member.man : 0
        const womanMember = room.member && room.member.woman ? room.member.woman : 0
        const manVisitor = room.visitors && room.visitors.man ? room.visitors.man : 0
        const womanVisitor =
          room.visitors && room.visitors.woman ? room.visitors.woman : 0
        const memberChildren = room.memberChildren
        const visitorChildren = room.visitorChildren
        // const visitors = room.visitors
        totalAdultHead += manMember + womanMember
        totalAdultMan += manMember
        totalAdultWoman += womanMember

        let totalPeople = room.adultCount + room.childrenCount

        const memberTotalChldCnt = Object.keys(memberChildren)
          .map((key) => memberChildren[key])
          .reduce((a, b) => a + b, 0)

        const vstTotalChldCnt = Object.keys(visitorChildren)
          .map((key) => visitorChildren[key])
          .reduce((a, b) => a + b, 0)

        totalMemberChilrenCnt += memberTotalChldCnt
        countChildrenA += memberChildren.childrenType10
        countChildrenB += memberChildren.childrenType15
        countChildrenC += memberChildren.childrenType20
        countChildrenD += memberChildren.childrenType30
        countChildrenE += memberChildren.childrenType40
        countChildrenF += memberChildren.childrenType50

        totalVisitAdult += manVisitor + womanVisitor
        totalVisitMan += manVisitor
        totalVisitWoman += womanVisitor
        totalVisitChilrenCnt += vstTotalChldCnt
        countVisitChildrenA += visitorChildren.childrenType10
        countVisitChildrenB += visitorChildren.childrenType15
        countVisitChildrenC += visitorChildren.childrenType20
        countVisitChildrenD += visitorChildren.childrenType30
        countVisitChildrenE += visitorChildren.childrenType40
        countVisitChildrenF += visitorChildren.childrenType50

        let peopleSlotCnt = 0
        peopleSlotCnt += Object.keys(memberChildren)
          .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
          .map((key) => memberChildren[key])
          .reduce((a, b) => a + b, 0)
        peopleSlotCnt += Object.keys(visitorChildren)
          .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
          .map((key) => visitorChildren[key])
          .reduce((a, b) => a + b, 0)

        const tmp_childInfos = planDetail.vacancyCalendar.childPriceInfo.childInfos

        const getChildEscrtFeeFlag = function(childInfos, childDiv) {
          if (childInfos == null || childDiv == null) {return 0}
          for (const childInfo of childInfos) {
            if (childInfo.childDiv == childDiv) {
              return childInfo.transFeeFlag
            }
          }
          return 0
        }

        const roomData = {
          acptPrtic: {
            gnrlChrg: null,
            tieupChrg: null,
            memberChrg: null,
            boneSbsidChrg: null,
            cnt: '1',
            dscntRatio: null,
            dscntAmt: null
          },
          stayPrtic: {
            aloctRoom: `${index + 1}部屋目`,
            roomId: _.get(planDetail, 'roomBasicInfo.roomId'),
            roomNm: _.get(planDetail, 'roomBasicInfo.roomNm'),
            roomChrgFlag: baseOnPrice === PLAN_BASE_ON_PRICE.ROOM ? '1' : '0',
            familyName: deputyInfo[index] ? deputyInfo[index].familyName : '',
            familyNameKana: deputyInfo[index] ? deputyInfo[index].familyNameKana : '',
            firstName: deputyInfo[index] ? deputyInfo[index].firstName : '',
            firstNameKana: deputyInfo[index] ? deputyInfo[index].firstNameKana : '',
            chldaEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.a),
            chldbEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.b),
            chldcEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.c),
            chlddEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.d),
            chldeEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.e),
            chldfEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.f),
            reserveId: _.get(bsAppState, 'bs_app_02_001.reserveId', '')
          },
          stayRoomDayPrticList: []
        }
        let boneSbsidChrgTemp = 0;
        for (let i = 0; i < this.customerPlan.stayNights; i++) {
          const stayRoomDay = room.stayDays[i] || null
          if (stayRoomDay) {
            if (stayRoomDay.roomPrice) {
              totalMemberChrg += stayRoomDay.price
            } else {
              totalMemberChrg +=
                (stayRoomDay.memberAdultChrg || 0) +
                (stayRoomDay.totalMemberChldChrg || 0)
              totalMemberChrg +=
                (stayRoomDay.visitorAdultChrg || 0) +
                (stayRoomDay.totalVisitorChldChrg || 0)
            }
            const memberAdultCnt = stayRoomDay.memberAdultCnt || 0
            const visitorAdultPrice = stayRoomDay.visitorAdultPrice || 0 // 提携料金算出の為、visitorPrice を使用
            if (stayRoomDay.roomPrice) {
              totalTieupChrg += stayRoomDay.roomPrice
            } else {
              if (stayRoomDay.memberAdultChrg < memberAdultCnt * visitorAdultPrice) {
                totalTieupChrg += memberAdultCnt * visitorAdultPrice
              } else {
                totalTieupChrg += stayRoomDay.memberAdultChrg
              }
              totalTieupChrg += Object.keys(stayRoomDay.memberChldCnt)
                .map(
                  (key) =>
                    (stayRoomDay.memberChldCnt[key] || 0) *
                    (stayRoomDay.visitorChldPrice[key] || 0)
                )
                .reduce((a, b) => a + b, 0)

              totalTieupChrg +=
                (stayRoomDay.visitorAdultChrg || 0) +
                (stayRoomDay.totalVisitorChldChrg || 0)
            }
          }
          const checkDay = moment(stayDay)
            .set('date', stayDay.get('date') + i)
            .format('YYYY/MM/DD')
          let stayDayDetail = null
          if (vacancyCalendars && Array.isArray(vacancyCalendars)) {
            stayDayDetail = vacancyCalendars.filter((e) => e.stayDay === checkDay).length
              ? vacancyCalendars.filter((e) => e.stayDay === checkDay)[0]
              : null
          }

          const checkroomcharge = function() {
            if (baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
              return stayDayDetail.price
            }
            return 0
          }
          // case: plan out of stock will be removed from vacancyCalendars
          if(!stayDayDetail) {
            stayDayDetail = this.getOriginCalendar?.filter((e) => e.stayDay === checkDay).length
              ? this.getOriginCalendar?.filter((e) => e.stayDay === checkDay)[0]
              : null
          }
          const day = {
            stayRoomDayPrtic: {
              aloctRoom: `${index + 1}部屋目`,
              roomId: planDetail.roomBasicInfo.roomId,
              stayDay: moment(stayDay)
                .set('date', stayDay.get('date') + i)
                .format(this.dateFormat),
              roomMemberChrg: checkroomcharge(),
              roomBoneSbsidChrg: 0,

              adultTotalHeadCnt: manMember + womanMember,
              adultManHeadCnt: manMember,
              adultWomanHeadCnt: womanMember,
              chldaManHeadCnt: room.chldaManHeadCnt,
              chldaWomanHeadCnt: room.chldaWomanHeadCnt,
              chldHeadCnt: memberTotalChldCnt,
              chldaHeadCnt: memberChildren.childrenType10,
              chldbHeadCnt: memberChildren.childrenType15,
              chldcHeadCnt: memberChildren.childrenType20,
              chlddHeadCnt: memberChildren.childrenType30,
              chldeHeadCnt: memberChildren.childrenType40,
              chldfHeadCnt: memberChildren.childrenType50,

              vistrAdultTotalHeadCnt: manVisitor + womanVisitor,
              vistrAdultManHeadCnt: manVisitor,
              vistrAdultWomanHeadCnt: womanVisitor,
              vistrChldHeadCnt: vstTotalChldCnt,
              vistrChldaHeadCnt: visitorChildren.childrenType10,
              vistrChldbHeadCnt: visitorChildren.childrenType15,
              vistrChldcHeadCnt: visitorChildren.childrenType20,
              vistrChlddHeadCnt: visitorChildren.childrenType30,
              vistrChldeHeadCnt: visitorChildren.childrenType40,
              vistrChldfHeadCnt: visitorChildren.childrenType50,

              adultMemberChrg: 0,
              chldaMemberChrg: 0,
              chldbMemberChrg: 0,
              chldcMemberChrg: 0,
              chlddMemberChrg: 0,
              chldeMemberChrg: 0,
              chldfMemberChrg: 0,
              
              adultvistrChrg: 0,
              chldavistrChrg: 0,
              chldbvistrChrg: 0,
              chldcvistrChrg: 0,
              chlddvistrChrg: 0,
              chldevistrChrg: 0,
              chldfvistrChrg: 0,
              vistrFlag: manVisitor + womanVisitor + vstTotalChldCnt ? '1' : '0',
              sglUseFlag:
                manMember +
                womanMember +
                memberTotalChldCnt +
                manVisitor +
                womanVisitor +
                vstTotalChldCnt
                  ? '1'
                  : '0',
              slepShrigFlag: peopleSlotCnt ? '1' : '0',

              getNumNmChrg: totalPeople,
              adult1useChldChrgDiv: _.get(
                menuStayParams,
                'vacancyCalendar.childPriceInfo.childFeeApplicationDiv',
                null
              )
            },
            stayMealInfoList: [
              {
                headCnt: null,
                mealDiv: null,
                mealId: null,
                mealNm: null,
                mealChrgUnit: null,
                mealChrgTotal: null
              }
            ]
          }
          if (baseOnPrice === PLAN_BASE_ON_PRICE.PEOPLE) {
            this.setStayRoomDayPrticBasePeople(day, room.stayDays[i], memberChildren, visitorChildren)
            day.stayRoomDayPrtic.roomBoneSbsidChrg = day.stayRoomDayPrtic.adultBoneSbsidChrg * day.stayRoomDayPrtic.adultTotalHeadCnt + day.stayRoomDayPrtic.chldaBoneSbsidChrg * day.stayRoomDayPrtic.chldaHeadCnt 
            + day.stayRoomDayPrtic.chldbBoneSbsidChrg * day.stayRoomDayPrtic.chldbHeadCnt + day.stayRoomDayPrtic.chldcBoneSbsidChrg * day.stayRoomDayPrtic.chldcHeadCnt
            + day.stayRoomDayPrtic.chlddBoneSbsidChrg * day.stayRoomDayPrtic.chlddHeadCnt + day.stayRoomDayPrtic.chldeBoneSbsidChrg * day.stayRoomDayPrtic.chldeHeadCnt 
            + day.stayRoomDayPrtic.chldfBoneSbsidChrg * day.stayRoomDayPrtic.chldfHeadCnt;
          } else {
            day.stayRoomDayPrtic.roomBoneSbsidChrg = room.stayDays[i]?.boneSubsidy ? +stayDayDetail.boneSubsidy : 0 ;
          }
          boneSbsidChrgTotalTemp = boneSbsidChrgTotalTemp + day.stayRoomDayPrtic.roomBoneSbsidChrg;
          boneSbsidChrgTemp = boneSbsidChrgTemp + day.stayRoomDayPrtic.roomBoneSbsidChrg;
          roomData['stayRoomDayPrticList'].push(day)
        }
        roomData.acptPrtic.boneSbsidChrg = boneSbsidChrgTemp;
        acptPrticDomesticStayList.push(roomData)
      })

      const lastCheckInTm = _.get(
        planDetail,
        'planUsage.usageDetailStay.lastCheckInTm',
        null
      )
      const checkInTm = _.get(planDetail, 'planUsage.usageDetailStay.checkInTm', null)
      const checkOutTm = _.get(planDetail, 'planUsage.usageDetailStay.checkOutTm', null)
      const totalDiscountAmount = _.get(couponPlanData, 'totalDiscountAmount', null)
      const benepoint = _.get(bsAppState, 'bs_app_02_008.point_benepo', null)
      const inputProfileData = _.get(this.$store.state, 'bs_app.bs_app.info_detail', null)
      const profileMe = this.$store.getters['auth/get'].profileMe
      const representativeInfo = _.get(this.bsApp02001, 'representativeInfo')
      /* 受注パターン区分は楽天・東横・ベネオリで異なる。デフォルトはベネオリ */
      const orderPatternDiv = this.getOrderPatternDiv();

      const nationalRoomData = {
        acptDtl: {
          acptDtlNo: null,
          travelBranchNo: 0,
          menuNo: _.get(planDetail, 'menuInformation.menuNo', null),
          planId: _.get(planDetail, 'planBasicInfo.planId', null),
          srvicDiv: _.get(planDetail, 'menuInformation.srvicDiv', null),
          usageDiv: _.get(planDetail, 'planUsage.usageDiv', null),
          orderPatternDiv: orderPatternDiv,
          useDate: moment(stayDay).format(this.dateFormat),
          useHeadCnt:
            totalAdultHead +
            totalMemberChilrenCnt +
            totalVisitAdult +
            totalVisitChilrenCnt,
          payeeDiv: this.CONST_DATA.PAYEE_DIV.MEMBER_STORE,
          cafePointAplyFlag: 0,
          pointAplyFlag: !this.$store.getters.isUseBenepoPoint ? '0' : '1',
          sbsidAplyFlag: !totalDiscountAmount ? '0' : '1',
          blshSysCd: this.siteController,
          payMethod: 10,
          catLrgClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catLrgClassNm',
            null
          ),
          catMidClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catMidClassNm',
            null
          ),
          catSmlClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catSmlClassNm',
            null
          ),
          rsvReqPaperAutoSendFlag: _.get(
            planDetail,
            'applInfo.rsvReqPaperAutoSendFlag',
            null
          )
            ? '1'
            : '0',
          ccOperatorHandleFlag: _.get(planDetail, 'applInfo.ccOperatorHandleFlag', null)
            ? '1'
            : '0',
          shippingFlag: _.get(planDetail, 'applInfo.shippingFlag', null) ? '1' : '0',
          usageLimitNotCountFlag: '0',
          usageLimitId: _.get(planDetail, 'usageLimitInformation[0].usageLimitId', null),
          documentId: Array.isArray(_.get(this.customerPlan, 'menuStayParams.optin'))
            ? _.get(this.customerPlan, 'menuStayParams.optin').map(
                (opt) => opt.documentId
              )
            : null
        },
        dtlChrgTotal: {
          gnrlChrgTotal: null,
          tieupChrgTotal: totalTieupChrg,
          memberChrgTotal: totalMemberChrg,
          boneSbsidChrgTotal: boneSbsidChrgTotalTemp,
          pointUse: benepoint,
          addChrg: null,
          bathTax: null,
          hotelTax: null,
          dscntAmtTotal: null,
          oficeFee: null,
          cafePointAmtTotal: null,
          sbsidTotal: totalDiscountAmount,
          totalAmt: bs_app_02_001.totalFee,
          billAmtTotal:
            bs_app_02_001.totalFee -
            ((totalDiscountAmount ? totalDiscountAmount : 0) +
              (benepoint ? benepoint : 0) + this.cafeApplyAmount),
          approvalAmt: null,
          approvalMemo: null,
          // peculiarCnsdrAmt: null,
          // peculiarCnsdrMemo: null,
          rktChildChrgDiffTotal: null
        },
        pointGrntInfo: null,
        sbsidRsvList: [],
        stayAcptDtl: {
          dstnc: '1',
          hope: '1',
          nightCnt: this.customerPlan.stayNights,
          roomCnt: this.customerPlan.stayRooms,
          adultTotalHeadCnt: totalAdultHead,
          adultManHeadCnt: totalAdultMan,
          adultWomanHeadCnt: totalAdultWoman,
          chldHeadCnt: totalMemberChilrenCnt,
          chldaHeadCnt: countChildrenA,
          chldbHeadCnt: countChildrenB,
          chldcHeadCnt: countChildrenC,
          chlddHeadCnt: countChildrenD,
          chldeHeadCnt: countChildrenE,
          chldfHeadCnt: countChildrenF,
          vistrAdultTotalHeadCnt: totalVisitAdult,
          vistrAdultManHeadCnt: totalVisitMan,
          vistrAdultWomanHeadCnt: totalVisitWoman,
          vistrChldHeadCnt: totalVisitChilrenCnt,
          vistrChldaHeadCnt: countVisitChildrenA,
          vistrChldbHeadCnt: countVisitChildrenB,
          vistrChldcHeadCnt: countVisitChildrenC,
          vistrChlddHeadCnt: countVisitChildrenD,
          vistrChldeHeadCnt: countVisitChildrenE,
          vistrChldfHeadCnt: countVisitChildrenF,
          chldInfo: null,
          homeDprtrDate: null,
          homeDprtrDateSecndHope: null,
          // outsideResrvId: null, // 楽天の場合のみ。ベネオリの場合はなし。
          rfrncNo: null,
          rfrncNo2: null,
          rfrncNo3: null,
          subMenuNm: null,
          useNum: null,
          fileSubmtInfoCorpNm: null,
          fileSubmtInfoYmd: null,
          fileSubmtInfoSeq: null,
          slepShrigHeadCnt: null,
          minorStayFlag: null,
          guardAgreeFlag: null,
          lastCheckInTm: lastCheckInTm
            ? `${lastCheckInTm.substring(0, 2)}:${lastCheckInTm.substring(2)}`
            : null,
          checkOutTm: checkOutTm
            ? `${checkOutTm.substring(0, 2)}:${checkOutTm.substring(2)}`
            : null,
          priceRemarks: _.get(this.customerPlan, 'vacancyCalendar.priceRemarks', null),
          breakfastFlag: _.get(
            planDetail,
            'planUsage.usageDetailStay.breakfastFlag',
            null
          ),
          dinnerFlag: _.get(planDetail, 'planUsage.usageDetailStay.dinnerFlag', null),
          parentMemberAccompanyFlag: _.get(
            bsAppState,
            'bs_app_02_001.valueCheckbox',
            null
          )
            ? '1'
            : '0',
          readOnlyFlag: _.get(
            bsAppState,
            'bs_app_02_001.menuStayParams.appInfo.readOnlyFlag',
            null
          )
        },
        stayResrvRpsntInfo: {
          resrvFamilyNmKana: _.get(profileMe, 'familyNameKana', null),
          resrvFirstNmKana: _.get(profileMe, 'firstNameKana', null),
          rpsntFamilyNm: representUserInfo && representUserInfo.familyName ? representUserInfo.familyName : _.get(profileMe, 'familyName', null),
          rpsntFirstNm: representUserInfo && representUserInfo.firstName ? representUserInfo.firstName : _.get(profileMe, 'firstName', null),
          rpsntFamilyNmKana: representUserInfo && representUserInfo.familyNameKana
            ? representUserInfo.familyNameKana
            : _.get(profileMe, 'familyNameKana', null),
          rpsntFirstNmKana: representUserInfo && representUserInfo.firstNameKana
            ? representUserInfo.firstNameKana
            :  _.get(profileMe, 'firstNameKana', null),
          rpsntBirthday: null,
          rpsntSex: representUserInfo.gender,
          rpsntEmail: null,
          rpsntTel: representativeInfo && representativeInfo.phoneNumber ? representativeInfo.phoneNumber : _.get(inputProfileData, 'tel', ''),
          rpsntZipCd: null,
          rpsntPrefectureCd: null,
          rpsntAddr1: null,
          rpsntAddr2: null,
          rpsntGen: null,
          note: null,
          rpsntRelationship: representUserInfo
            ? representUserInfo.familyRelationship
            : null,
          rpsntVistrFlag: representUserInfo.isVisitor ? '1' : '0',
          rpsntAge: representUserInfo.age
        },
        othInfo: {
          moveDiv: _.get(bs_app_02_001, 'othInfo.moveDiv', null),
          ckinSchDatetime: `${this.checkinTime}:00`,
          ckoutSchDatetime: checkOutTm
            ? `${checkOutTm.substring(0, 2)}:${checkOutTm.substring(2)}`
            : null
        },
        stayPlanQstnReplyList: _.get(bs_app_02_001, 'questionList', []).map((qst) => {
          return {
            qstn: _.get(qst, 'qstnCont', null),
            replyRem: _.get(qst, 'replyRem', null),
            qstnReplyIdpsbFlag: _.get(qst, 'qstnReplyIdpsbFlag', null) ? '1' : '0'
          }
        }),
        stayPlanCancelList: _.get(planDetail, 'cancelPolicy.cancelPolicies', []).map(
          (e) => {
            return {
              stayPlanCancel: {
                cancelTitle: e.cancelTitle,
                cancelNote1: e.cancelNote1,
                cancelNote2: e.cancelNote2,
                webCancelAvailDiv: _.get(
                  planDetail,
                  'cancelPolicy.webCancelAvailDiv',
                  null
                ),
                cancelTaxExcChargeFlag: !!_.get(
                  planDetail,
                  'cancelPolicy.canclTaxExcChrgFlag',
                  null
                )
                  ? _.get(
                  planDetail,
                  'cancelPolicy.canclTaxExcChrgFlag'
                )
                  : '0',
                groupCancelPolicyFlag: null
              },
              stayPlanCancelPrticList: Array.isArray(e.cancelPolicyTable)
                ? e.cancelPolicyTable.map((e) => {
                    e.cancelChargeOth = 0
                    return e
                  })
                : []
            }
          }
        ),
        acptPrticDomesticStayList
      }

      const stayNightDetails = _.get(couponPlanData, 'stayNightDetails') || []
      const sbsidRsvList = []
      const stayUsrStrctList = []
      stayNightDetails.forEach((night, nIndex) => {
        const stayDay = night.stayDay
        night.rooms.forEach((room) => {
          room.relationships.forEach((relation) => {
            relation.appliedCoupons.forEach((coupon) => {
              sbsidRsvList.push({
                subsidyRsvId: coupon.availableData.subsidyId,
                subsidyDetailId: coupon.availableData.subsidyDetailId,
                // customerNo: _.get(this.userInfo, 'contract.customerNo', null),
                customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
                relationship: _.get(relation, 'relationship.relationshipId', null),
                couponId: _.get(coupon, 'availableData.couponInfo[0].couponId', ''), // 63752 どのcouponIdを指定してもよいため、最初のcouponIdをリクエストボディに含める
                priceId: _.get(coupon, 'applyPrice.subsidyPriceId', null),
                amount: coupon.price,
                familyName: _.get(relation, 'familyName', null),
                firstName: _.get(relation, 'firstName', null),
                aloctRoom: null,
                roomId: planDetail.roomBasicInfo.roomId,
                stayDay: moment(stayDay).format(this.dateFormat),
                ageDiv: _.get(coupon, 'applyPrice.ageType', ''),
                groupId: _.get(coupon, 'availableData.groupInfo.groupId', null)
              })
            })
            if(nIndex === 0)
            {
              stayUsrStrctList.push({
                familyName: _.get(relation, 'familyName', null),
                firstName: _.get(relation, 'firstName', null),
                age: _.get(relation, 'age', null),
              })
            }
          })
        })
      })
      nationalRoomData.sbsidRsvList = sbsidRsvList
      nationalRoomData.stayUsrStrctList = stayUsrStrctList
      console.log('check6：申請する補助金情報 => ', sbsidRsvList);   

      if (currentOrder && currentOrder.acptDtlNo) {
        nationalRoomData['acptDtl']['acptDtlNo'] = currentOrder?.acptDtlNo
      } else if (this.customerPlan && this.customerPlan.acptDtlNo) {
        nationalRoomData['acptDtl']['acptDtlNo'] = this.customerPlan.acptDtlNo
      }
      data['acptDtlDomesticStayList'] = [nationalRoomData]
    },
    /**
    * 宿泊リクエストデータ作成
    */
    setStayRequestInfo(data) {
      const baseOnPrice = this.baseOnPrice
      const planDetail = this.getPlanDetail
      const bsAppState = this.bsAppState
      const bsApp = this.$store.getters.bs_app
      const bs_app_02_001 = bsApp.bs_app_02_001
      const deputyInfo = bs_app_02_001.deputyInfo
      const currentOrder = this.getOrderInfo
      const vacancyCalendars =
        this.customerPlan && this.customerPlan.vacancyCalendar
          ? this.customerPlan.vacancyCalendar.vacancyCalendars
          : []
      const stayDay = moment(this.customerPlan.stayDay)
      const menuStayParams = _.get(bsAppState, 'bs_app_02_001.menuStayParams', null)
      const representUserInfo = bs_app_02_001 ? bs_app_02_001.inputFormData : null
      // const profile = _.get(bsAppState, 'bs_app_02_001.profileInfo', null)
      const couponPlanData = this.customerPlan.couponPlanData
      let totalAdultHead = 0
      let totalAdultMan = 0
      let totalAdultWoman = 0
      let totalMemberChilrenCnt = 0
      let countChildrenA = 0
      let countChildrenB = 0
      let countChildrenC = 0
      let countChildrenD = 0
      let countChildrenE = 0
      let countChildrenF = 0
      /// visit
      let totalVisitAdult = 0
      let totalVisitMan = 0
      let totalVisitWoman = 0
      let totalVisitChilrenCnt = 0
      let countVisitChildrenA = 0
      let countVisitChildrenB = 0
      let countVisitChildrenC = 0
      let countVisitChildrenD = 0
      let countVisitChildrenE = 0
      let countVisitChildrenF = 0

      let totalMemberChrg = 0
      let totalTieupChrg = 0
      let boneSbsidChrgTotalTemp = 0
      const acptPrticStayRequestList = []
      bs_app_02_001.stayRoomDetails.forEach((room, index) => {
        const manMember = room.member && room.member.man ? room.member.man : 0
        const womanMember = room.member && room.member.woman ? room.member.woman : 0
        const manVisitor = room.visitors && room.visitors.man ? room.visitors.man : 0
        const womanVisitor =
          room.visitors && room.visitors.woman ? room.visitors.woman : 0
        const memberChildren = room.memberChildren
        const visitorChildren = room.visitorChildren
        // const visitors = room.visitors
        totalAdultHead += manMember + womanMember
        totalAdultMan += manMember
        totalAdultWoman += womanMember

        let totalPeople = room.adultCount + room.childrenCount

        const memberTotalChldCnt = Object.keys(memberChildren)
          .map((key) => memberChildren[key])
          .reduce((a, b) => a + b, 0)

        const vstTotalChldCnt = Object.keys(visitorChildren)
          .map((key) => visitorChildren[key])
          .reduce((a, b) => a + b, 0)

        totalMemberChilrenCnt += memberTotalChldCnt
        countChildrenA += memberChildren.childrenType10
        countChildrenB += memberChildren.childrenType15
        countChildrenC += memberChildren.childrenType20
        countChildrenD += memberChildren.childrenType30
        countChildrenE += memberChildren.childrenType40
        countChildrenF += memberChildren.childrenType50

        totalVisitAdult += manVisitor + womanVisitor
        totalVisitMan += manVisitor
        totalVisitWoman += womanVisitor
        totalVisitChilrenCnt += vstTotalChldCnt
        countVisitChildrenA += visitorChildren.childrenType10
        countVisitChildrenB += visitorChildren.childrenType15
        countVisitChildrenC += visitorChildren.childrenType20
        countVisitChildrenD += visitorChildren.childrenType30
        countVisitChildrenE += visitorChildren.childrenType40
        countVisitChildrenF += visitorChildren.childrenType50

        let peopleSlotCnt = 0
        peopleSlotCnt += Object.keys(memberChildren)
          .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
          .map((key) => memberChildren[key])
          .reduce((a, b) => a + b, 0)
        peopleSlotCnt += Object.keys(visitorChildren)
          .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
          .map((key) => visitorChildren[key])
          .reduce((a, b) => a + b, 0)

        const tmp_childInfos = planDetail.vacancyCalendar.childPriceInfo.childInfos

        const getChildEscrtFeeFlag = function(childInfos, childDiv) {
          // 戻り値 1 は、利率を表すコード
          if (childInfos == null || childDiv == null) {return 1}
          for (const childInfo of childInfos) {
            if (childInfo.childDiv == childDiv) {
              return childInfo.transFeeFlag
            }
          }
          return 1
        }

        const roomData = {
          acptPrtic: {
            gnrlChrg: null,
            tieupChrg: null,
            memberChrg: null,
            boneSbsidChrg: null,
            cnt: '1',
            dscntRatio: null,
            dscntAmt: null
          },
          stayPrtic: {
            aloctRoom: `${index + 1}部屋目`,
            roomId: _.get(planDetail, 'roomBasicInfo.roomId'),
            roomNm: _.get(planDetail, 'roomBasicInfo.roomNm'),
            roomChrgFlag: baseOnPrice === PLAN_BASE_ON_PRICE.ROOM ? '1' : '0',
            familyName: deputyInfo[index] ? deputyInfo[index].familyName : '',
            familyNameKana: deputyInfo[index] ? deputyInfo[index].familyNameKana : '',
            firstName: deputyInfo[index] ? deputyInfo[index].firstName : '',
            firstNameKana: deputyInfo[index] ? deputyInfo[index].firstNameKana : '',
            chldaEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.a),
            chldbEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.b),
            chldcEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.c),
            chlddEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.d),
            chldeEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.e),
            chldfEscrtFeeFlag: getChildEscrtFeeFlag(tmp_childInfos, CHILD_DIV.f),
            reserveId: null
          },
          stayRoomDayPrticList: []
        }
        let boneSbsidChrgTemp = 0;
        for (let i = 0; i < this.customerPlan.stayNights; i++) {
          const stayRoomDay = room.stayDays[i] || null
          if (stayRoomDay) {
            if (stayRoomDay.roomPrice) {
              totalMemberChrg += stayRoomDay.price
            } else {
              totalMemberChrg +=
                (stayRoomDay.memberAdultChrg || 0) +
                (stayRoomDay.totalMemberChldChrg || 0)
              totalMemberChrg +=
                (stayRoomDay.visitorAdultChrg || 0) +
                (stayRoomDay.totalVisitorChldChrg || 0)
            }
            const memberAdultCnt = stayRoomDay.memberAdultCnt || 0
            const visitorAdultPrice = stayRoomDay.visitorAdultPrice || 0 // 提携料金算出の為、visitorPrice を使用
            if (stayRoomDay.roomPrice) {
              totalTieupChrg += stayRoomDay.roomPrice
            } else {
              if (stayRoomDay.memberAdultChrg < memberAdultCnt * visitorAdultPrice) {
                totalTieupChrg += memberAdultCnt * visitorAdultPrice
              } else {
                totalTieupChrg += stayRoomDay.memberAdultChrg
              }
              totalTieupChrg += Object.keys(stayRoomDay.memberChldCnt)
                .map(
                  (key) =>
                    (stayRoomDay.memberChldCnt[key] || 0) *
                    (stayRoomDay.visitorChldPrice[key] || 0)
                )
                .reduce((a, b) => a + b, 0)

              totalTieupChrg +=
                (stayRoomDay.visitorAdultChrg || 0) +
                (stayRoomDay.totalVisitorChldChrg || 0)
            }
          }
          const checkDay = moment(stayDay)
            .set('date', stayDay.get('date') + i)
            .format('YYYY/MM/DD')
          let stayDayDetail = null
          if (vacancyCalendars && Array.isArray(vacancyCalendars)) {
            stayDayDetail = vacancyCalendars.filter((e) => e.stayDay === checkDay).length
              ? vacancyCalendars.filter((e) => e.stayDay === checkDay)[0]
              : null
          }

          const checkroomcharge = function() {
            if (baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
              return stayDayDetail.price
            }
            return 0
          }
          // case: plan out of stock will be removed from vacancyCalendars
          if(!stayDayDetail) {
            stayDayDetail = this.getOriginCalendar?.filter((e) => e.stayDay === checkDay).length
              ? this.getOriginCalendar?.filter((e) => e.stayDay === checkDay)[0]
              : null
          }
          const day = {
            aloctRoom: `${index + 1}部屋目`,
            roomId: planDetail.roomBasicInfo.roomId,
            stayDay: moment(stayDay)
              .set('date', stayDay.get('date') + i)
              .format(this.dateFormat),
            roomMemberChrg: checkroomcharge(),
            adultMemberChrg: 0,
            chldaMemberChrg: 0,
            chldbMemberChrg: 0,
            chldcMemberChrg: 0,
            chlddMemberChrg: 0,
            chldeMemberChrg: 0,
            chldfMemberChrg: 0,

            roomBoneSbsidChrg: 0,

            adultBoneSbsidChrg: 0,
            chldaBoneSbsidChrg: 0,
            chldbBoneSbsidChrg: 0,
            chldcBoneSbsidChrg: 0,
            chlddBoneSbsidChrg: 0,
            chldeBoneSbsidChrg: 0,
            chldfBoneSbsidChrg: 0,

            adultTotalHeadCnt: manMember + womanMember,
            adultManHeadCnt: manMember,
            adultWomanHeadCnt: womanMember,
            chldHeadCnt: memberTotalChldCnt,
            chldaHeadCnt: memberChildren.childrenType10,
            chldbHeadCnt: memberChildren.childrenType15,
            chldcHeadCnt: memberChildren.childrenType20,
            chlddHeadCnt: memberChildren.childrenType30,
            chldeHeadCnt: memberChildren.childrenType40,
            chldfHeadCnt: memberChildren.childrenType50,

            vistrAdultTotalHeadCnt: manVisitor + womanVisitor,
            vistrAdultManHeadCnt: manVisitor,
            vistrAdultWomanHeadCnt: womanVisitor,
            vistrChldHeadCnt: vstTotalChldCnt,
            vistrChldaHeadCnt: visitorChildren.childrenType10,
            vistrChldbHeadCnt: visitorChildren.childrenType15,
            vistrChldcHeadCnt: visitorChildren.childrenType20,
            vistrChlddHeadCnt: visitorChildren.childrenType30,
            vistrChldeHeadCnt: visitorChildren.childrenType40,
            vistrChldfHeadCnt: visitorChildren.childrenType50,

            vistrFlag: manVisitor + womanVisitor + vstTotalChldCnt ? '1' : '0',

            sglUseFlag:
              manMember +
              womanMember +
              memberTotalChldCnt +
              manVisitor +
              womanVisitor +
              vstTotalChldCnt
                ? '1'
                : '0',
            slepShrigFlag: peopleSlotCnt ? '1' : '0',
            getNumNmChrg: totalPeople,
            adult1useChldChrgDiv: _.get(
              menuStayParams,
              'vacancyCalendar.childPriceInfo.childFeeApplicationDiv',
              null
            )
          }
          if (baseOnPrice === PLAN_BASE_ON_PRICE.PEOPLE) {
            this.setStayRoomDayPrticBasePeopleForStayRequest(day, room.stayDays[i]);
            day.roomBoneSbsidChrg = day.adultBoneSbsidChrg * day.adultTotalHeadCnt + day.chldaBoneSbsidChrg * day.chldaHeadCnt
              + day.chldbBoneSbsidChrg * day.chldbHeadCnt + day.chldcBoneSbsidChrg * day.chldcHeadCnt
              + day.chlddBoneSbsidChrg * day.chlddHeadCnt + day.chldeBoneSbsidChrg * day.chldeHeadCnt
              + day.chldfBoneSbsidChrg * day.chldfHeadCnt;
          } else {
            day.roomBoneSbsidChrg = room.stayDays[i]?.boneSubsidy ? +stayDayDetail.boneSubsidy : 0 ;
          }
          boneSbsidChrgTotalTemp = boneSbsidChrgTotalTemp + day.roomBoneSbsidChrg;
          boneSbsidChrgTemp = boneSbsidChrgTemp + day.roomBoneSbsidChrg;
          roomData['stayRoomDayPrticList'].push(day)
        }
        roomData.acptPrtic.boneSbsidChrg = boneSbsidChrgTemp;
        acptPrticStayRequestList.push(roomData)
      })

      const lastCheckInTm = _.get(
        planDetail,
        'planUsage.usageDetailStay.lastCheckInTm',
        null
      )
      // const checkInTm = _.get(planDetail, 'planUsage.usageDetailStay.checkInTm', null)
      const checkOutTm = _.get(planDetail, 'planUsage.usageDetailStay.checkOutTm', null)
      const totalDiscountAmount = _.get(couponPlanData, 'totalDiscountAmount', null)
      const benepoint = _.get(bsAppState, 'bs_app_02_008.point_benepo', null)
      const inputProfileData = _.get(this.$store.state, 'bs_app.bs_app.info_detail', null)
      const profileMe = this.$store.getters['auth/get'].profileMe
      const representativeInfo = _.get(this.bsApp02001, 'representativeInfo')
      /* 受注パターン区分は楽天・東横・ベネオリで異なる。デフォルトはベネオリ */
      const orderPatternDiv = this.getOrderPatternDiv();

      const nationalRoomData = {
        acptDtl: {
          acptDtlNo: null,
          travelBranchNo: 0,
          menuNo: _.get(planDetail, 'menuInformation.menuNo', null),
          planId: _.get(planDetail, 'planBasicInfo.planId', null),
          srvicDiv: _.get(planDetail, 'menuInformation.srvicDiv', null),
          usageDiv: _.get(planDetail, 'planUsage.usageDiv', null),
          orderPatternDiv: orderPatternDiv,
          useDate: moment(stayDay).format(this.dateFormat),
          useHeadCnt:
            totalAdultHead +
            totalMemberChilrenCnt +
            totalVisitAdult +
            totalVisitChilrenCnt,
          payeeDiv: this.CONST_DATA.PAYEE_DIV.MEMBER_STORE,
          cafePointAplyFlag: 0,
          pointAplyFlag: !this.$store.getters.isUseBenepoPoint ? '0' : '1',
          sbsidAplyFlag: !totalDiscountAmount ? '0' : '1',
          blshSysCd: this.siteController,
          payMethod: 10,
          catLrgClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catLrgClassNm',
            null
          ),
          catMidClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catMidClassNm',
            null
          ),
          catSmlClassNm: _.get(
            planDetail,
            'menuInformation.categoryInfomation.catSmlClassNm',
            null
          ),
          rsvReqPaperAutoSendFlag: _.get(
            planDetail,
            'applInfo.rsvReqPaperAutoSendFlag',
            null
          )
            ? '1'
            : '0',
          judgeFlag: "1",
          ccOperatorHandleFlag: _.get(planDetail, 'applInfo.ccOperatorHandleFlag', null)
            ? '1'
            : '0',
          shippingFlag: _.get(planDetail, 'applInfo.shippingFlag', null) ? '1' : '0',
          usageLimitNotCountFlag: '0',
          usageLimitId: _.get(planDetail, 'usageLimitInformation[0].usageLimitId', null),
          documentId: Array.isArray(_.get(this.customerPlan, 'menuStayParams.optin'))
            ? _.get(this.customerPlan, 'menuStayParams.optin').map(
                (opt) => opt.documentId
              )
            : null
        },
        dtlChrgTotal: {
          gnrlChrgTotal: null,
          tieupChrgTotal: totalTieupChrg,
          memberChrgTotal: totalMemberChrg,
          boneSbsidChrgTotal: boneSbsidChrgTotalTemp,
          pointUse: benepoint,
          addChrg: null,
          bathTax: null,
          hotelTax: null,
          dscntAmtTotal: null,
          oficeFee: null,
          cafePointAmtTotal: null,
          sbsidTotal: totalDiscountAmount,
          totalAmt: bs_app_02_001.totalFee,
          billAmtTotal:
            bs_app_02_001.totalFee -
            ((totalDiscountAmount ? totalDiscountAmount : 0) +
              (benepoint ? benepoint : 0) + this.cafeApplyAmount),
          approvalAmt: null,
          approvalMemo: null
          // peculiarCnsdrAmt: null,
          // peculiarCnsdrMemo: null,
          // rktChildChrgDiffTotal: null
        },
        pointGrntInfo: null,
        sbsidRsvList: [],
        stayAcptDtl: {
          dstnc: '1',
          hope: '1',
          nightCnt: this.customerPlan.stayNights,
          roomCnt: this.customerPlan.stayRooms,
          adultTotalHeadCnt: totalAdultHead,
          adultManHeadCnt: totalAdultMan,
          adultWomanHeadCnt: totalAdultWoman,
          chldHeadCnt: totalMemberChilrenCnt,
          chldaHeadCnt: countChildrenA,
          chldbHeadCnt: countChildrenB,
          chldcHeadCnt: countChildrenC,
          chlddHeadCnt: countChildrenD,
          chldeHeadCnt: countChildrenE,
          chldfHeadCnt: countChildrenF,
          vistrAdultTotalHeadCnt: totalVisitAdult,
          vistrAdultManHeadCnt: totalVisitMan,
          vistrAdultWomanHeadCnt: totalVisitWoman,
          vistrChldHeadCnt: totalVisitChilrenCnt,
          vistrChldaHeadCnt: countVisitChildrenA,
          vistrChldbHeadCnt: countVisitChildrenB,
          vistrChldcHeadCnt: countVisitChildrenC,
          vistrChlddHeadCnt: countVisitChildrenD,
          vistrChldeHeadCnt: countVisitChildrenE,
          vistrChldfHeadCnt: countVisitChildrenF,
          chldInfo: null,
          homeDprtrDate: null,
          homeDprtrDateSecndHope: null,
          // outsideResrvId: null, // 楽天の場合のみ。ベネオリの場合はなし。
          rfrncNo: null,
          rfrncNo2: null,
          rfrncNo3: null,
          subMenuNm: null,
          useNum: null,
          fileSubmtInfoCorpNm: null,
          fileSubmtInfoYmd: null,
          fileSubmtInfoSeq: null,
          slepShrigHeadCnt: null,
          minorStayFlag: null,
          guardAgreeFlag: null,
          lastCheckInTm: lastCheckInTm
            ? `${lastCheckInTm.substring(0, 2)}:${lastCheckInTm.substring(2)}`
            : null,
          checkOutTm: checkOutTm
            ? `${checkOutTm.substring(0, 2)}:${checkOutTm.substring(2)}`
            : null,
          priceRemarks: _.get(this.customerPlan, 'vacancyCalendar.priceRemarks', null),
          breakfastFlag: _.get(
            planDetail,
            'planUsage.usageDetailStay.breakfastFlag',
            null
          ),
          dinnerFlag: _.get(planDetail, 'planUsage.usageDetailStay.dinnerFlag', null),
          parentMemberAccompanyFlag: _.get(
            bsAppState,
            'bs_app_02_001.valueCheckbox',
            null
          )
            ? '1'
            : '0',
          readOnlyFlag: _.get(
            bsAppState,
            'bs_app_02_001.menuStayParams.appInfo.readOnlyFlag',
            null
          ),
          advancePayment: '0',
        },
        stayResrvRpsntInfo: {
          resrvFamilyNmKana: _.get(profileMe, 'familyNameKana', null),
          resrvFirstNmKana: _.get(profileMe, 'firstNameKana', null),
          rpsntFamilyNm: representUserInfo && representUserInfo.familyName ? representUserInfo.familyName : _.get(profileMe, 'familyName', null),
          rpsntFirstNm: representUserInfo && representUserInfo.firstName ? representUserInfo.firstName : _.get(profileMe, 'firstName', null),
          rpsntFamilyNmKana: representUserInfo && representUserInfo.familyNameKana
            ? representUserInfo.familyNameKana
            : _.get(profileMe, 'familyNameKana', null),
          rpsntFirstNmKana: representUserInfo && representUserInfo.firstNameKana
            ? representUserInfo.firstNameKana
            :  _.get(profileMe, 'firstNameKana', null),
          rpsntBirthday: null,
          rpsntSex: representUserInfo.gender,
          rpsntEmail: null,
          rpsntTel: representativeInfo && representativeInfo.phoneNumber ? representativeInfo.phoneNumber : _.get(inputProfileData, 'tel', ''),
          rpsntZipCd: null,
          rpsntPrefectureCd: null,
          rpsntAddr1: null,
          rpsntAddr2: null,
          rpsntGen: null,
          note: null,
          rpsntRelationship: representUserInfo
            ? representUserInfo.familyRelationship
            : null,
          rpsntVistrFlag: representUserInfo.isVisitor ? '1' : '0',
          rpsntAge: representUserInfo.age
        },
        othInfo: {
          moveDiv: _.get(bs_app_02_001, 'othInfo.moveDiv', null),
          ckinSchDatetime: `${this.checkinTime}:00`,
          ckoutSchDatetime: checkOutTm
            ? `${checkOutTm.substring(0, 2)}:${checkOutTm.substring(2)}`
            : null
        },
        stayPlanQstnReplyList: _.get(bs_app_02_001, 'questionList', []).map((qst) => {
          return {
            qstn: _.get(qst, 'qstnCont', null),
            replyRem: _.get(qst, 'replyRem', null),
            qstnReplyIdpsbFlag: _.get(qst, 'qstnReplyIdpsbFlag', null) ? '1' : '0'
          }
        }),
        stayPlanCancelList: _.get(planDetail, 'cancelPolicy.cancelPolicies', []).map(
          (e) => {
            return {
              stayPlanCancel: {
                cancelTitle: e.cancelTitle,
                cancelNote1: e.cancelNote1,
                cancelNote2: e.cancelNote2,
                webCancelAvailDiv: _.get(
                  planDetail,
                  'cancelPolicy.webCancelAvailDiv',
                  null
                ),
                cancelTaxExcChargeFlag: !_.get(
                  planDetail,
                  'cancelPolicy.canclTaxExcChrgFlag',
                  null
                )
                  ? _.get(
                  planDetail,
                  'cancelPolicy.canclTaxExcChrgFlag'
                )
                  : '0',
                groupCancelPolicyFlag: null
              },
              stayPlanCancelPrticList: Array.isArray(e.cancelPolicyTable)
                ? e.cancelPolicyTable.map((e) => {
                    e.cancelChargeOth = 0
                    return e
                  })
                : []
            }
          }
        ),
        acptPrticStayRequestList
      }

      const stayNightDetails = _.get(couponPlanData, 'stayNightDetails') || []
      const sbsidRsvList = []
      const stayUsrStrctList = []
      stayNightDetails.forEach((night, nIndex) => {
        const stayDay = night.stayDay
        night.rooms.forEach((room) => {
          room.relationships.forEach((relation) => {
            relation.appliedCoupons.forEach((coupon) => {
              sbsidRsvList.push({
                subsidyRsvId: coupon.availableData.subsidyId,
                subsidyDetailId: coupon.availableData.subsidyDetailId,
                // customerNo: _.get(this.userInfo, 'contract.customerNo', null),
                customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
                relationship: _.get(relation, 'relationship.relationshipId', null),
                couponId: _.get(coupon, 'availableData.couponInfo[0].couponId', ''), // 63752 どのcouponIdを指定してもよいため、最初のcouponIdをリクエストボディに含める
                priceId: _.get(coupon, 'applyPrice.subsidyPriceId', null),
                amount: coupon.price,
                familyName: _.get(relation, 'familyName', null),
                firstName: _.get(relation, 'firstName', null),
                aloctRoom: null,
                roomId: planDetail.roomBasicInfo.roomId,
                stayDay: moment(stayDay).format(this.dateFormat),
                ageDiv: _.get(coupon, 'applyPrice.ageType', ''),
                groupId: _.get(coupon, 'availableData.groupInfo.groupId', null)
              })
            })
            if(nIndex === 0)
            {
              stayUsrStrctList.push({
                familyName: _.get(relation, 'familyName', null),
                firstName: _.get(relation, 'firstName', null),
                age: _.get(relation, 'age', null),
              })
            }
          })
        })
      })
      nationalRoomData.sbsidRsvList = sbsidRsvList
      nationalRoomData.stayUsrStrctList = stayUsrStrctList
      console.log('check6：申請する補助金情報 => ', sbsidRsvList);

      if (currentOrder && currentOrder.acptDtlNo) {
        nationalRoomData['acptDtl']['acptDtlNo'] = currentOrder?.acptDtlNo
      } else if (this.customerPlan && this.customerPlan.acptDtlNo) {
        nationalRoomData['acptDtl']['acptDtlNo'] = this.customerPlan.acptDtlNo
      }
      data['acptDtlStayRequestList'] = [nationalRoomData]
    },
    isStayRequest() {
      const bsAppData = this.bsAppState;
      return _.get(bsAppData, 'bs_app_02_001.isStayRequest', false);
    },
    /**
     * オーダーデータ作成および送信
     */
    async completeOrder() {
      this.$loading.show();
      const query = this.$route.query;

      let data = this.getInitOrderData();
      if (this.isStayRequest()) {
        this.setStayRequestInfo(data);
      } else {
        this.setStayInfo(data);
      }

      const order_confirm = {
        feePeople: this.feePeople,
        fee4: this.fee4,
        applyBenepoints: this.applyBenepoints,
        totalSubsidyDiscount: this.totalSubsidyDiscount,
        grantedBenepo: this.grantedBenepo,
        totalCost: this.totalCost,
        totalAdult: this.totalAdultPeople,
        totalChild: this.totalChildren,
        acptNo: null,
        aplyCafePointAmt: data.cafeApplyAmount,
        aplySbsidAmt: data.aplySbsidAmt
      }

      /**
       * TODO
       * 0円での申し込みをさせない処理に変更
       * 宿泊料金が0となる事象解明でき次第解除すること
       * 4/10：テストの為一旦解除
       */

      const pointUseNumAmt = data.pointUseNumAmt;
      const aplyCafePointAmt = data.cafeApplyAmount;
      const aplySbsidAmt = data.aplySbsidAmt;
      const totalCost = this.totalCost;
      const discountTotal = pointUseNumAmt + aplyCafePointAmt + aplySbsidAmt;
      //   if (totalCost <= 0) {
      // 	this.$loading.hide();
      //     this.$toasted.error('ご予約が中断されました。再度、はじめからお申込みください');
      // 	return;
      //   }

      console.log("data.actNo", data.actNo);
      console.log("data", data);
      console.log("this.isStayRequest()", this.isStayRequest());
      const isStayRequest = this.isStayRequest();
      console.log("isStayRequest", isStayRequest);
      this.$store.dispatch('order/setOrderConfirm', order_confirm)

      // 事前決済時処理
      if(this.payeeDivMethod === 'credit'){
        this.$store.dispatch('order/setPayeeDivMethod', this.payeeDivMethod)
        data.acptDtlDomesticStayList[0].stayAcptDtl['advancePayment'] = '1'

        // 負担額が発生する場合のみ決済GWを経由
        if(totalCost > 0){
          const payParam = {
            orderId: this.getOrderId,
            totalDiscountAmount: aplySbsidAmt,
            benepoint: pointUseNumAmt,
            cafeApplyAmount: aplyCafePointAmt,
            email: _.get(this.getInfoDetail, 'email', ''),
          }
          const settlement = await this.$repositories('order').selectPay(payParam)
                                  .then(
                                    (data) => {
                                      return data
                                    },
                                    (error) => {
                                      return null;
                                    })
          
          if(!settlement) {
            this.$loading.hide()
            this.$toasted.error('エラーが発生しました');
            this.isNextClickEnabled = true;
            return;
          }

          // 事前決済関連処理の制御のためステート保持
          sessionStorage.setItem('redirectOrderDetail', JSON.stringify(data))
          sessionStorage.setItem('confirmQuery', JSON.stringify(this.$route.query))
          sessionStorage.setItem('documentTitle', document.title)
          this.$store.commit(SET_ORDER, data)

          // 遷移時のダイアログ表示を無効化
          window.onbeforeunload = () => {}

          // 決済GWへ飛ばす
          this.$loading.hide()
          if (process.env.VUE_APP_DEV_MODE === constData.ENV.LOCAL) {
            const query = {
              tid: "wg59wODSEGHKd3dPh8AThc%2BxahIJIASNQLSQIwKoxSc%3D",
              param: "a8Y3J6BG%2FymcgCIytMkW8%2FSE%2B0R3%2B0%2FHlZeGN9a38WoHLCmGaA27ZpYdzG1cR1%2FjDc06rbZWwUP5X2vZKP4Cm8a7Ebsxj7mu4ubNkha203lw87qf%2Bk1wMiZCBtHeu3WYeaGWqRYwadhFmizWoDw3K7HZMwZGi7uribBB7x5F7M0JOP4qSvxi9Xod5UkQv99%2B9cxOzMh2Q4Uod%2FpEkN0wDZE1WdHVCUbnMJw5FrBuW%2BEvRCFmCgmVYLrajREED4MjjR9vrDcROwhckaLgNsGWAg%3D%3D",
            }
            const params = new URLSearchParams(query);
            location.href = 
              process.env.VUE_APP_BASE_URL + '/orders/complete?' + params;
          }
          else {
            
            location.href =
              process.env.VUE_APP_URL_PAYMENT_GATEWAY + `${settlement}`;
          }

          // 受注登録は決済完了後に実施
          return;
        }
      }

      if (data.acptNo) {
        this.$store.dispatch(UPDATE_ORDER, data).then(
          () => {
            this.$loading.hide()
            if (this.pointRemain) {
              this.$auth.points = this.pointRemain
            }
            this.$toasted.success('オーダー更新が成功しました。')
            this.$router.push({ path: 'register-complete', query })
          },
          (error) => {
            this.$loading.hide()
            this.$toasted.error(error?.message)
            this.isNextClickEnabled = true;
          }
        )
      } else if (isStayRequest) { // 宿泊リクエスト
        this.$store.dispatch(CREATE_STAY_REQUEST, data).then(
          (response) => {
            this.$loading.hide()

            // bff が落ちていた場合、responce に値は存在せず
            if(!response){
              this.$toasted.error('宿泊リクエストの申込に失敗しました')
              this.isNextClickEnabled = true;
              return
            }

            if (this.pointRemain) {
              this.$auth.points = this.pointRemain
            }
            if (!response) {
              this.$toasted.error('宿泊リクエストの申込に失敗しました');
              this.isNextClickEnabled = true;
              return;
            }
            order_confirm.acptNo = _.get(response, 'acptNo')

            // 楽天の場合は、楽天トラベル予約番号を完了画面で表示する必要がある
            const extSystemCd = _.get(this.getPlanInfo, 'menuInformation.extSystemCd', '')
            if (extSystemCd == 'RakutenT') {
              order_confirm.outsideResrvId = _.get(response, 'outsideResrvId', null)
            }

            this.$store.dispatch('order/setOrderConfirm', order_confirm)
            this.$toasted.success('宿泊リクエストが成功しました。')
            this.$router.push({ path: 'register-complete', query })
          },
          (error) => {
            this.$loading.hide()
            this.isNextClickEnabled = true;
            try { 
              const messageError = error.message || error.error.message
              if(messageError && Array.isArray(messageError) ){
                let errorText =  ''
                messageError.forEach((error)=>{
                  errorText += `${error?.errorMsg} <br> `
                })
                this.$toasted.error(errorText);
              } else if(messageError){
                this.$toasted.error(messageError);
              } else {
              this.$toasted.error('宿泊リクエストの申込に失敗しました')
              }
            } catch (error) {
              this.$toasted.error('宿泊リクエストの申込に失敗しました')
            }
          }
        );
      } else { // 通常予約
        this.$store.dispatch(CREATE_ORDER, data).then(
          (response) => {
            this.$loading.hide()

            // bff が落ちていた場合、responce に値は存在せず
            if(!response){
              this.$toasted.error('申込に失敗しました')
              this.isNextClickEnabled = true;
              return
            }

            if (this.pointRemain) {
              this.$auth.points = this.pointRemain
            }

            order_confirm.acptNo = _.get(response, 'acptNo')

            // 楽天の場合は、楽天トラベル予約番号を完了画面で表示する必要がある
            const extSystemCd = _.get(this.getPlanInfo, 'menuInformation.extSystemCd', '')
            if (extSystemCd == 'RakutenT') {
              order_confirm.outsideResrvId = _.get(response, 'outsideResrvId', null)
            }

            this.$store.dispatch('order/setOrderConfirm', order_confirm)
            this.$toasted.success('オーダー作成が成功しました。')
            this.$router.push({ path: 'register-complete', query })
          },
          (error) => {
            let messageError = error.message || error.error.message
            // 楽天リフレッシュからのエラーを使用して楽天ログイン確認モーダルを表示するようにする
            if(messageError === 'RAKUTEN_TOKEN_EXPIRED'){
              const bsAppData = this.bsAppState;
              const reserveId = _.get(bsAppData, 'bs_app_02_001.reserveId', '')
              data.reserveId = reserveId
              data.totalCost = this.totalCost
              sessionStorage.setItem('redirectOrderDetail', JSON.stringify(data))
              this.setConfirm(true);
              this.$loading.hide();
              this.isNextClickEnabled = true;
            } else {
              this.$loading.hide();
              this.isNextClickEnabled = true;
              try {
                if (typeof messageError === 'string') {
                  // 文字列の場合の処理
                  try {
                    messageError = JSON.parse(messageError);
                    if (Array.isArray(messageError)) {
                      // 配列の場合の処理
                      let errorText = '';
                      messageError.forEach((error) => {
                        errorText += `${error?.errorMsg || error} <br> `;
                      });
                      this.$toasted.error(errorText);
                      
                    } else {
                      this.$toasted.error(messageError.errorMsg);
                    }
                  
                  } catch (e) {
                    // パースに失敗した場合はそのまま使用
                      this.$toasted.error(messageError);
                  }
                } else {
                  // その他の場合
                  this.$toasted.error('申込に失敗しました');
                }
              } catch (error) {
                this.$toasted.error('申込に失敗しました');
              }
            }
          }
        )
      }
    },
    onClickOpenCoupon() {
      this.popupUseCoupon = true
    },
    async onApplyCoupon($event) {
      this.activeCafe = true;
      this.activeCouponBtn = false;
      this.popupUseCoupon = false;
      const customerPlan = _.cloneDeep(this.customerPlan);
      customerPlan['couponPlanData'] = _.cloneDeep($event);
      await this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan);
      // update coupon discount
      // カフェ情報を再取得
      this.setCafeData();
    },
    async donotUseCoupon() {
      this.activeCouponBtn = false;
      if (this.isCafeDisplay) {
        this.activeCafe = true;
      } else {
        this.cafeAppliedFlg = true;
      }
      this.couponOptionTotalPopUp = null;
      await this.getSubsidyCoupons();
      if (this.couponOptionTotal) {
        this.noUseCouponOption = true;
      }
      this.couponOptionTotal = null;
      // カフェ情報を再取得
      this.setCafeData();
    },
    unuseBenepoint() {
      //this.activeCouponBtn = false;
      this.activeBtnBenepoint = false;
      this.checkedBenepoint = 2;
      this.clearBenepoint();
      this.$store.commit('savePointCheckedBox', 2);
    },
    resetCoupons() {
      bus.$emit('resetCouponScreen');
      this.checkedBenepoint = null;
      this.activeCouponBtn = true;
      this.activeBtnBenepoint = false;
      this.couponOptionTotalPopUp = null;
      this.getSubsidyCoupons();
    },
    handleOkBenePopup() {
      this.activeBtnBenepoint = false;
    },
    /**
    * プラン確定ボタン押下処理
    */
    async handleNext() {
      await this.mutex.lock();
      try {
        if (this.isNextClickEnabled) {
          this.isNextClickEnabled = false;
          // 宿泊料金が0円の場合
          if (this.feePeople <= 0) {
            this.$toasted.error("ご予約が中断されました。再度、はじめからお申込みください");
            this.isNextClickEnabled = true;
            return;
          }

          // 獲得予定ベネポを再取得してからオーダーデータ作成を実施
          const result = await this.getGrantedBenePoint();
          if (result === -1) {
            this.$toasted.error(
              '情報の更新に失敗しました。\nお手数ですが「やり直す」ボタンを押下し、各ポイントを再申請してください。',
              { className: 'toasted-multiline' }
            );
            this.isNextClickEnabled = true;
            return;
          }
          const finalBenepo = result !== null ? result : (this.grantedBenepo || 0);
          this.pointGrntNumAmt = finalBenepo;
          this.grantedBenepo = finalBenepo;
          this.completeOrder();
        }
      } finally {
        this.mutex.unlock();
      }
    },
    handleChange($event) {
      this.paymentMethod = $event.toString()
    },
    handlePayment() {
      const data = this.getInitOrderData()
      this.setStayInfo(data)
      const bs_app_02_005 = {
        totalCost: this.totalCost
      }
      data.orderInfoComplete = this.getOrderComplete()
      data.totalCost = this.totalCost
      this.orderDetail = data
      this.$repositories('plan')
        .putPay({
          menuNm: _.get(this.getPlanDetail, 'menuInformation.menuNm', ''),
          billingAmount: this.totalCost
        })
        .then(
          (response) => {
            if (response) {
              if (process.env.NODE_ENV !== 'local') {
                location.href = `${process.env.VUE_APP_URL_PAYMENT_GATEWAY}${response}`
              } else {
                this.$router.push({
                  path: '/register-confirmation/loading',
                  query: {
                    param:
                      '1G26a0BWFO0mug0e82DeCW74TUzQquDhSYY7v7ha6Nl%2FLeFDxSFiMqjQ8I4J%2F%2BsYvB5V92jFkpMuqGp0z42NN9IzQQe86Jq4FRU1a9ebQuo8Tza0k0KSxyK7TUXliFEtxQoPqxObpWzvUxuBYxvuM3ofP%2FO47Q5IszsSs%2FJ%2FIYGQsXRM1YcxdlG26TDNOamxtUyQmMLGJbmtpnavcosnFNeMK%2F%2BpDgjJZD6TMfqiqJZk9d%2FzEA%2FrHEy94nT46dPEpRALW2sTMpDPed5ytcextw%3D%3D'
                  }
                })
              }
            }
          },
          (error) => {
            this.$toasted.error('エラーが発生しました')
          }
        )
      const dataOrderComplete = this.getOrderComplete()
      this.$store.commit('order/set', data)
      this.$store.commit('order/setOrderComplete', dataOrderComplete)
    },
    getOrderComplete() {
      let data = null
      let dataItem = null
      const orderInfo = this.getOrderInfo
      const planInfo = _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
      const planBasicInfo = _.get(planInfo, 'planBasicInfo', null)
      if (planInfo && planBasicInfo) {
        dataItem = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(planInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(planInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
      const planState = _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
      const countAdult =
        _.get(orderInfo, 'acptDtlDomesticStayList[0].stayAcptDtl.adultTotalHeadCnt', '') +
        _.get(
          orderInfo,
          'acptDtlDomesticStayList[0].stayAcptDtl.vistrAdultTotalHeadCnt',
          ''
        )
      const countChild =
        _.get(orderInfo, 'acptDtlDomesticStayList[0].stayAcptDtl.chldHeadCnt', '') +
        _.get(orderInfo, 'acptDtlDomesticStayList[0].stayAcptDtl.vistrChldHeadCnt', '')
      const bs_app_02_001 = _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001', null)
      )
      const queryParam = this.$route.query

      data = {
        acptNo: _.get(orderInfo, 'acptNo', ''),
        acptDtlNo: _.get(orderInfo, 'acptDtlNo', ''),
        dataItemOrder: dataItem,
        stayDayJP: _.get(planState, 'stayDayJP', null),
        stayNights: _.get(planState, 'stayNights', null),
        stayRooms: _.get(planState, 'stayRooms', null),
        totalAdult: countAdult,
        totalChild: countChild,
        value_time_picker: _.get(bs_app_02_001, 'checkinTime', ''),
        finalOrderAmount: this.totalCost,
        query: queryParam
      }
      return data
    },
    handleEdit(code) {
      const query = this.$route.query
      switch (code) {
        case 1:
          this.$router.push({ path: '/register-address', query })
          return
        case 2:
          this.$router.push({ path: '/register-rooms', query })
          return
        case 3:
          this.$router.push({ path: '/register-coupon', query })
          return
        case 4:
          this.$router.push({ path: '/register-benepo', query })
      }
    },
    clearBenepoint() {
      this.activeBtnBenepoint = false;
      // this.getBsApp02008.checkedValue = 0
      this.$store.dispatch(SAVE_DATA_BS_APP_02_008, null).then(() => {})
      const bsApp02008Data = _.cloneDeep(this.getBsApp02008)
      if (bsApp02008Data) {
        this.checkedBenepoint = bsApp02008Data.checkedValue
        bsApp02008Data.pointRemain = bsApp02008Data.pointRemain + this.applyBenepoints
        bsApp02008Data.point_benepo = 0
        this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bsApp02008Data)
      }
    },
    handleBack() {
      const query = this.$route.query
      this.$router.push({ path: '/register-rooms', query })
    },
    gotoPath(code) {
      const query = this.$route.query
      const { menuNo, planId, roomId } = this.$route.query
      switch (code) {
        case 1:
          this.$router.push({ path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}` })
          return
        case 2:
          this.$router.push({ path: '/register-rooms', query })
      }
    },
    getCustomerInfo(el) {
      this.customerInfo = el
    },
    openAddressInfo() {
      this.popupAddressInfo = true
    },
    updateInfoCustomer(data) {
      this.updatePostCode = data
    },
    async setCafeData() {
      const planDetail   = this.getPlanDetail;
      const couponForce  = this.couponForceTotal ? this.couponForceTotal : 0;
      const couponOption = this.couponOptionTotal ? this.couponOptionTotal : 0;
      const useDate      = this.customerPlan.stayDay ? moment(this.customerPlan.stayDay).format('YYYYMMDD') : moment().format('YYYYMMDD');
      const dayCount     = this.customerPlan.stayNights ? this.customerPlan.stayNights : 1;
      const visitorPrice = this.calcTotalVisitorPrice();
      this.useDate    = useDate;
      this.calcCoupon = couponForce + couponOption;
      
      const reqParam = {
        catLrgClassCd: _.get(
          planDetail,
          'menuInformation.categoryInfomation.catLrgClassCd',
          ''
        ),
        catMidClassCd: _.get(
          planDetail,
          'menuInformation.categoryInfomation.catMidClassCd',
          ''
        ),
        catSmlClassCd: _.get(
          planDetail,
          'menuInformation.categoryInfomation.catSmlClassCd',
          ''
        ),
        menuNo: this.$store.getters.planDetail.menuInformation.menuNo,
        planId: this.$store.getters.planDetail.planBasicInfo.planId,
        receivableFlag: '1',
        ticketExclusionFlag: _.get(
          planDetail,
          'planUsage.usageDetail.ticketExclusionFlag',
          ''
        ),
        buppanExclusionFlag: _.get(
          planDetail,
          'planUsage.usageDetail.buppanExclusionFlag',
          ''
        ),
        famiExclusionFlag: _.get(
          planDetail,
          'planUsage.usageDetail.famiExclusionFlag',
          ''
        ),
        totalPrice: this.feePeople - this.calcCoupon - visitorPrice,
        dayCount: dayCount,
        useDate: useDate
      };
      this.$repositories("order").getCafeInfo(reqParam).then(
        (response) => {
          if (response.counts === 0) {
            this.cafeAppliedFlg = true;
            // カフェ非表示の場合は、下記の場合ベネポ申請ボタンを押下可状態にする
            // 補助金なし または 強制補助金のみ または 補助金申請済み
            if (this.subsidyAvailables.length === 0 || this.forcedCouponOnly || this.cannotApplyCoupon || !this.activeCouponBtn) {
              this.activeBtnBenepoint = true;
            }
          } else {
            const result = response.cafeMenuInfo.sort((a, b) => {
            return (a.cafeMenuNo < b.cafeMenuNo) ? -1 : 1;
            });
            this.cafeData = result;
            this.isCafeDisplay = true;
            // 下記の場合は、カフェ申請ボタン押下可、ベネポ申請ボタンを押下不可状態にする
            // 補助金なし または 強制補助金のみ または 補助金申請済み
            if (this.subsidyAvailables.length === 0 || this.forcedCouponOnly || this.cannotApplyCoupon || !this.activeCouponBtn) {
            this.activeCafe = true;
            this.activeBtnBenepoint = false;
            }
          }
        },
        (error) => {
          this.cafeAppliedFlg = true;
          // カフェ非表示の場合は、下記の場合ベネポ申請ボタンを押下可状態にする
          // 補助金なし または 強制補助金のみ または 補助金申請済み
          if (this.subsidyAvailables.length === 0 || this.forcedCouponOnly || this.cannotApplyCoupon || !this.activeCouponBtn) {
            this.activeBtnBenepoint = true;
          }
        }
      );
    },
    showCafeModal() {
      this.popupUseCafe = true;
    },
    setUseCafe(retVal) {
      this.cafeMenuNo = retVal.cafeMenuNo;
      this.cafeMenuBranchNo = retVal.cafeMenuBranchNo;
      this.cafeApplyAmount = retVal.cafeApplyAmount || 0;
      this.cafeApplyPoint = retVal.cafeApplyPoint;
      this.cafeLabel = "利用する";
      this.cafeAppliedFlg = true;
      this.activeCafe = false;
      this.activeBtnBenepoint = true;
    },
    hideCafeModal() {
      this.popupUseCafe = false;
    },
    clearCafe() {
      if (this.subsidyAvailables.length === 0 || this.forcedCouponOnly || this.cannotApplyCoupon) {
        if (this.isCafeDisplay) {
          this.cafeMenuNo = "";
          this.cafeMenuBranchNo = "";
          this.cafeApplyAmount = 0;
          this.cafeApplyPoint = 0;
          this.cafeLabel = "利用しない";
          this.cafeAppliedFlg = false;
          this.activeCafe = true;
          this.activeBtnBenepoint = false;
        } else {
          this.cafeAppliedFlg = true;
          this.activeCafe = false;
          this.activeBtnBenepoint = true;
        }
      } else {
        this.cafeMenuNo = "";
        this.cafeMenuBranchNo = "";
        this.cafeApplyAmount = 0;
        this.cafeApplyPoint = 0;
        this.cafeLabel = "利用しない";
        this.cafeAppliedFlg = false;
        this.activeCafe = false;
      }
    },
    notUseCafe() {
      this.cafeAppliedFlg = true;
      this.activeCafe = false;
      this.activeBtnBenepoint = true;
    },
    calcMemberCount() {
      const stayRoomDetails = _.get(this.bsApp02001, 'stayRoomDetails');
      let memberAdults   = 0;
      let memberChildren = 0;
      stayRoomDetails.forEach((rooms) => {
        memberAdults   += rooms.member.man + rooms.member.woman;
        memberChildren += rooms.memberChildren.childrenType10;
        memberChildren += rooms.memberChildren.childrenType15;
        memberChildren += rooms.memberChildren.childrenType20;
        memberChildren += rooms.memberChildren.childrenType30;
        memberChildren += rooms.memberChildren.childrenType40;
        memberChildren += rooms.memberChildren.childrenType50;
      });
      this.memberAdultsCnt   = memberAdults;
      this.memberChildrenCnt = memberChildren;
    },
    calcMemberPrice() {
    let memberPrice = 0;
      const visitorPrice = this.calcTotalVisitorPrice();
      this.totalMemberPrice = this.feePeople - visitorPrice;
    },
    calcTotalVisitorPrice() {
      const stayRoomDetails = _.get(this.bsApp02001, 'stayRoomDetails');
      let totalVisitorPrice = 0;
      stayRoomDetails.forEach((rooms) => {
        rooms.displayVisitors.forEach((visitors) => {
          visitors.stayDays.forEach((day) => {
            totalVisitorPrice += day.price * day.quantity;
          })
        })
      });
      return totalVisitorPrice;
    },
    getOrderPatternDiv() {
      let orderPatternDiv = 10;
      /* 外部システムコードを取得し、受注パターン区分の判定を行う */
      const extSystemCd = _.get(this.getPlanInfo, 'menuInformation.extSystemCd', '')
      switch(extSystemCd) {
        case 'RakutenT':
          orderPatternDiv = 11;
          break;
        case 'ToyokoInn':
          orderPatternDiv = 12;
          break;
      }
      return orderPatternDiv;
    },
    async loginRakuten() {
      // 楽天ログイン後は完了画面に遷移
      const baseUrl = process.env.VUE_APP_BASE_URL;
      const path = '/register-complete'
      const queryParams = { ...this.$route.query, fromR: '1'}
      const query = new URLSearchParams(queryParams).toString();
      const rakutenRedirectUrl = `${baseUrl}${path}?${query}`;
      const encodedState = encodeURIComponent(rakutenRedirectUrl);
      // 楽天側がOMNI UI新システムのログインになったことからセッション時間が10分になったため、リフレッシュトークンの有効期限を570秒（9分30秒）にすることで片落ち制御。楽天側のセッションが直り次第削除。
      const maxAge = 570;
      location.href = `${process.env.VUE_APP_RAKUTEN_LOGIN_DOMAIN}/sso/authorize?response_type=code&client_id=rakutentravel_beneone_jp&redirect_uri=${process.env.VUE_APP_API_URL}/v1/stay/rakuten/login&state=${encodedState}&scope=openid+travel_booking_book+travel_booking_cancel+travel_booking_refer&service_id=t22&ui_locales=ja-JP&max_age=${maxAge}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.modify-button {
  @apply my-6 text-right;
}
.a-select {
  min-width: 100px;
}

::v-deep .ant-collapse-item {
  border: none !important;
  background-color: white !important;
}

.btn-disable {
  background-color: #cccccc;
}

.available-coupon-balloon {
  font-size: 0.875rem;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background-color: #259bee;
  border-radius: 4px;
  padding: 9px 55px;
  position: relative;
  margin-right: 10px;
  @include mq() {
    max-width: none;
    padding: 10px;
    text-align: center;
    > p {
      margin-bottom: 0;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 0px;
    height: 0px;
    margin: auto;
    right: -19px;
    border-style: solid;
    border-color: transparent transparent transparent #259bee;
    border-width: 10px 10px 10px 10px;

    @include mq() {
      top: 20px;
    }
  }
}
</style>
